const messages = {
  pt: {
    translations: {
      signup: {
        title: 'Crie sua conta',
        toasts: {
          success: 'Cadastro realizado com sucesso! Faça login para acessar o sistema.',
          fail: 'Erro ao criar usuário. Verifique os dados informados.',
        },
        form: {
          name: 'Nome',
          email: 'Email',
          password: 'Senha',
          company: 'Nome da Empresa',
          phone: 'Whatsapp (DDD + NÚMERO)',
        },
        buttons: {
          submit: 'Cadastrar',
          login: 'Já tem uma conta? Entre!',
        },
      },
      flowStatus: {
        label: 'Fluxo',
        attending: 'Fluxo "{{flow}}" atendendo',
        attendingUnnamed: 'Um fluxo está atendendo',
        stop: 'Encerrar o fluxo',
        confirmTitle: 'Encerrar fluxo',
        confirmBody:
          'Encerrar o fluxo que está atendendo este ticket? Ele não volta sozinho, e as respostas que o cliente já deu continuam guardadas.',
      },
      aiAgentStatus: {
        attending: '{{agent}} atendendo',
        idle: 'Nenhum agente de IA atendendo',
        paused: '{{agent}} pausado até {{time}} — um atendente respondeu pelo celular',
        until: 'até {{time}}',
        stop: 'Parar {{agent}}',
        resume: 'Retomar {{agent}} agora',
      },
      activateAiAgent: {
        button: 'Ativar agente de IA',
        title: 'Ativar agente de IA',
        subtitle: 'Escolha o agente que assume esta conversa',
        notice:
          'O ticket vai para a aba Automação, sem atendente e sem fila. Um fluxo em andamento é encerrado. O agente responde a partir da próxima mensagem do cliente.',
        empty: 'Nenhum agente de IA cadastrado. Crie um em Agentes de IA.',
        cancel: 'Cancelar',
        confirm: 'Ativar',
      },
      login: {
        title: 'Login',
        form: {
          email: 'Email',
          password: 'Senha',
          button: 'Acessar',
        },
        buttons: {
          submit: 'Entrar no Sistema',
          register: 'Cadastre-se agora!',
        },
      },
      companies: {
        title: 'Cadastrar Empresa',
        form: {
          name: 'Nome da Empresa',
          plan: 'Escolha o Plano',
          token: 'Token',
          submit: 'Cadastrar',
          success: 'Empresa criada com sucesso!',
        },
      },
      auth: {
        toasts: {
          success: 'Login efetuado com sucesso!',
        },
        dueDate: {
          expiration: 'Sua assinatura expira em',
          days: 'dias!',
          day: 'dia!',
          expirationToday: 'Sua assinatura expira hoje!',
        },
        token: 'Token',
      },
      dashboard: {
        tabs: {
          indicators: 'Indicadores',
          assessments: 'NPS',
          attendants: 'Atendentes',
        },
        charts: {
          perDay: {
            title: 'Atendimentos hoje: ',
          },
        },
        cards: {
          inAttendance: 'Em Atendimento',
          waiting: 'Aguardando',
          activeAttendants: 'Atendentes Ativos',
          finalized: 'Finalizados',
          newContacts: 'Novos Contatos',
          totalReceivedMessages: 'Mensagens Recebidas',
          totalSentMessages: 'Mensagens Enviadas',
          averageServiceTime: 'T.M. de Atendimento',
          averageWaitingTime: 'T.M. de Espera',
          status: 'Status (Atual)',
          activeTickets: 'Tickets Ativos',
          passiveTickets: 'Tickets Passivos',
          groups: 'Grupos',
        },
        users: {
          name: 'Nome',
          numberAppointments: 'Quantidade de Atendimentos',
          statusNow: 'Atual',
          totalCallsUser: 'Total de atendimentos por usuario',
          totalAttendances: 'TOTAL DE ATENDIMENTOS POR PERÍODO',
        },
        date: {
          initialDate: 'Data Inicial',
          finalDate: 'Data Final',
        },
        licence: {
          available: 'Disponível até',
        },
        assessments: {
          totalCalls: 'Total de Atendimentos',
          callsWaitRating: 'Atendimentos aguardando avaliação',
          callsWithoutRating: 'Atendimentos sem avaliação',
          ratedCalls: 'Atendimentos avaliados',
          evaluationIndex: 'Índice de avaliação',
          score: 'Pontuação',
          prosecutors: 'Promotores',
          neutral: 'Neutros',
          detractors: 'Detratores',
        },
      },
      reportsSurvey: {
        title: 'Relatório de Pesquisas Realizadas',
        operator: 'Operador',
        period: 'Período',
        until: 'Até',
        date: 'Data',
        reportTitle: 'Relatórios',
        calls: 'Atendimentos',
        search: 'Pesquisas',
        durationCalls: 'Duracão dos atendimentos',
        grupoSessions: 'Atendimentos em grupos',
        groupTicketsReports: {
          timezone: 'America/Sao_Paulo',
          msgToast: 'Gerando relatório compactado, por favor aguarde.',
          errorToast: 'Erro ao gerar o relatório',
          back: 'Voltar',
          groupServiceReport: 'Relatório de Atendimento em Grupos',
          loading: 'Carregando...',
          contact: 'Contato',
          dateOpen: 'Data abertura',
          dateLastUpdated: 'Data Última Atualização',
          agent: 'Quem atendeu',
          agentClosed: 'Quem fechou',
          waitingAssistance: 'Aguardando atendimento',
          process: 'Em atendimento',
        },
        researchReports: {
          response: 'resposta',
          active: '(Ativa)',
          inactive: '(Inativa)',
          quantity: 'Quantidade',
          percentage: 'porcentagem',
          title: 'Relatório de Pesquisas Realizadas',
          activeSearch: 'Pesquisa ativa',
          inactiveSearch: 'Pesquisa inativa',
        },
        ticketDurationDetail: {
          msgToast: 'Gerando relatório compactado, por favor aguarde.',
          title: 'Relatório de Duração do Atendimento',
          startService: 'Início do atendimento',
          lastUpdated: 'Última atualização',
          lastAgent: 'Último atendente',
          durationFinished: 'Duração após finalizado',
        },
        ticketDuration: {
          title: 'Relatório de Duração dos Atendimento',
          contact: 'Contato',
          open: 'Abertos',
          pending: 'Pendentes',
          finished: 'Finalizados',
          durationFinished: 'Duração dos finalizados',
          durationAfterFinished: 'Duração após finalizado',
          actions: 'Ações',
        },
        ticketReports: {
          msgToast: 'Gerando relatório compactado, por favor aguarde.',
          title: 'Relatório de Atendimento',
        },
        pdf: {
          title: 'Relação de Atendimentos Realizados',
          exportTitle: 'Relação de Atendimentos em Grupos Realizados',
        },
      },
      todo: {
        newTask: 'Nova Tarefa',
        add: 'Adicionar',
        task: 'Tarefas',
      },
      contactImportWpModal: {
        title: 'Exportar Contatos para o Excel',
        buttons: {
          downloadModel: 'Download modelo do excel para importação',
          closed: 'Fechar',
          import: 'Selecione o arquivo do excel para importar Contatos',
        },
      },
      superAdmin: {
        connections: {
          title: 'Conexões (Suporte)',
          subtitle: 'Suporte de sessões WhatsApp/Meta por empresa',
          subtitleWithCount: '{{count}} empresas com conexões',
          backToMonitoring: 'Voltar ao monitoramento',
          searchPlaceholder: 'Buscar empresa...',
          search: 'Buscar',
          refresh: 'Atualizar',
          empty: 'Nenhuma empresa com conexões encontrada.',
          manage: 'Gerenciar',
          drawerTitle: 'Conexões da empresa',
          columns: {
            company: 'Empresa',
            total: 'Conexões',
            status: 'Status',
            channels: 'Canais',
            lastActivity: 'Última atividade',
            actions: 'Ações',
          },
          status: {
            allConnected: 'Todas conectadas',
            partial: 'Parcial',
            allDown: 'Todas desconectadas',
          },
        },
        monitoring: {
          connectionsButton: 'Conexões',
        },
      },
      connections: {
        title: 'Conexões',
        waitConnection: 'Aguarde... Suas conexões serão reiniciadas!',
        newConnection: 'Nova Conexão',
        restartConnections: 'Reiniciar Conexões',
        callSupport: 'Chamar Suporte',
        toasts: {
          deleted: 'Conexão excluída com sucesso!',
          disconnected: 'Conexão desconectada com sucesso!',
          closedimported: 'Estamos fechando os tickets importados, por favor aguarde uns instantes',
        },
        facebook: {
          success: 'Conexão Facebook/Instagram conectada com sucesso!',
          errorConfig: 'Configuração Facebook não disponível.',
          connecting: 'Conectando...',
          redirecting: 'Redirecionando...',
          errorRedirect: 'Erro. Redirecionando...',
          errorNoUserId: 'Não foi possível obter o ID do usuário.',
          popupBlocked: 'Popup bloqueado. Permita popups neste site e tente novamente.',
        },
        meta: {
          openAuth: 'Janela de autorização aberta. Conclua o fluxo.',
        },
        confirmationModal: {
          closedImportedTitle: 'Fechar tickets importados',
          closedImportedMessage: 'Se você confirmar todos os tickets importados serão fechados',
          deleteTitle: 'Deletar',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida.',
          disconnectTitle: 'Desconectar',
          disconnectMessage: 'Tem certeza? Você precisará ler o QR Code novamente.',
          disconnectMetaMessage:
            'Tem certeza? A integração com Facebook/Instagram será desconectada.',
        },
        buttons: {
          add: 'Adicionar Conexão',
          disconnect: 'desconectar',
          tryAgain: 'Tentar novamente',
          qrcode: 'QR CODE',
          newQr: 'Novo QR CODE',
          closedImported: 'Fechar todos os tickets Importados',
          preparing: 'Preparando mensagens para importação',
          importing: 'Importando Mensagens do WhatsApp',
          processed: 'Processado',
          in: 'de',
          connecting: 'Conectando',
        },
        typography: {
          processed: 'Processado',
          in: 'de',
          date: 'Data da mensagem',
        },
        toolTips: {
          disconnected: {
            title: 'Falha ao iniciar sessão do WhatsApp',
            content:
              'Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code',
            titleMeta: 'Falha na integração com Facebook/Instagram',
            contentMeta:
              'A conexão com o Facebook ou Instagram foi perdida. Clique em reconectar para reautorizar.',
          },
          qrcode: {
            title: 'Esperando leitura do QR Code',
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: 'Conexão estabelecida!',
          },
          timeout: {
            title: 'A conexão com o celular foi perdida',
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: 'Nome',
          status: 'Status',
          lastUpdate: 'Última atualização',
          default: 'Padrão',
          actions: 'Ações',
          session: 'Sessão',
          number: 'Número do Whatsapp',
        },
      },
      showTicketOpenModal: {
        title: {
          header: 'Atendimento Existente',
        },
        form: {
          message: 'Este contato já está em atendimento:',
          user: 'Atendente',
          queue: 'Fila',
          messageWait: 'Este contato já está aguardando atendimento. Veja na aba Aguardando!',
        },
      },
      showTicketLogModal: {
        title: {
          header: 'Histórico do ticket',
          subtitle: 'Linha do tempo do atendimento',
        },
        empty: 'Nenhum registro encontrado.',
        end: 'Início do histórico',
        system: 'Sistema',
        flow: 'Fluxo',
        agent: 'Agente',
        aiEvents: {
          agentNamed: 'agente "{{name}}"',
          agentUnnamed: 'agente de IA',
          startedBy: '{{user}} ativou o {{agent}} nesta conversa.',
          started: 'O {{agent}} começou a atender.',
          removedBy: '{{user}} tirou o {{agent}} da conversa.',
          exited: 'O {{agent}} saiu da conversa.',
          paused: 'O {{agent}} pausou: um atendente respondeu pelo celular.',
          resumedBy: '{{user}} retomou o {{agent}}.',
          resumed: 'O {{agent}} voltou a atender.',
          transferred: 'O {{agent}} transferiu a conversa para o {{target}}.',
        },
        meta: {
          from: 'De',
          queue: 'Departamento',
          user: 'Atendente',
          reason: 'Motivo',
          comment: 'Observação',
          client: 'Cliente',
          tag: 'Tag',
          waited: 'Tempo de espera',
          opportunity: 'Oportunidade',
          pipeline: 'Funil',
          stage: 'Etapa',
          value: 'Valor',
          note: 'Nota',
          sendAt: 'Envia em',
          pausedUntil: 'Até',
        },
        options: {
          create: 'Ticket criado.',
          chatBot: 'ChatBot iniciado.',
          queue: ' - Fila definida.',
          open: ' iniciou o atendimento.',
          access: 'acessou o ticket.',
          transfered: 'transferiu o ticket.',
          receivedTransfer: 'recebeu o ticket transferido.',
          pending: 'devolveu a fila.',
          closed: 'fechou o ticket',
          reopen: 'reabriu o ticket',
          redirect: '- redirecionado',
          autoClose: 'fechado automaticamente.',
          userDefine: 'definiu o atendente.',
          nps: 'avaliação (NPS).',
          delete: 'excluiu o ticket.',
          retriesLimitQueue: 'limite de tentativas na fila.',
          retriesLimitUserDefine: 'limite de tentativas do atendente.',
          linkClient: 'vinculou um cliente.',
          tagAdded: 'adicionou uma tag.',
          tagRemoved: 'removeu uma tag.',
          leadValueChanged: 'alterou o valor do lead.',
          firstResponse: 'respondeu pela primeira vez.',
          opportunityLinked: 'criou uma oportunidade no CRM.',
          noteAdded: 'adicionou uma observação interna.',
          taskCreated: 'criou uma tarefa.',
          scheduleCreated: 'agendou uma mensagem.',
          scheduleUpdated: 'alterou uma mensagem agendada.',
          scheduleDeleted: 'cancelou uma mensagem agendada.',
          opportunityManaged: 'registrou/atualizou uma oportunidade no CRM.',
        },
      },
      closeTicketReasonModal: {
        title: 'Encerrar atendimento',
        subtitle: 'Selecione o motivo do fechamento',
        reasonLabel: 'Motivo',
        reasonRequired: 'Selecione um motivo para encerrar',
        noReasons: 'Nenhum motivo cadastrado. Cadastre em Configurações.',
        commentLabel: 'Observação (opcional)',
        buttons: {
          cancel: 'Cancelar',
          confirm: 'Encerrar',
        },
      },
      whatsappModal: {
        embeddedSignup: {
          notConfigured:
            'Cadastro Incorporado não configurado. Fale com o administrador da plataforma.',
          expiredSession: 'Sessão expirada. Tente novamente.',
          incomplete: 'A Meta não devolveu todos os dados da conexão. Tente novamente.',
          onlyWaba:
            'A conta do WhatsApp foi criada, mas nenhum número foi cadastrado. Abra o fluxo de novo e conclua o cadastro do número — a conta criada é reaproveitada.',
          error: 'A Meta recusou a conexão: {{message}}',
          errorWithSession: 'A Meta recusou a conexão: {{message}} (sessão {{sessionId}})',
          errorFallback: 'erro não informado',
          unexpected: 'A Meta encerrou o fluxo de forma inesperada ({{event}}).',
          invalidPin: 'O PIN precisa ter 6 dígitos.',
          registerRefused:
            'A Meta recusou o registro. Confira o PIN da verificação em duas etapas do número.',
          registerFailed: 'Não foi possível registrar o número. Tente de novo.',
        },
        title: {
          add: 'Adicionar Conexão',
          edit: 'Editar Conexão',
        },
        tabs: {
          general: 'Geral',
          messages: 'Mensagens',
          assessments: 'NPS',
          integrations: 'Integrações',
          schedules: 'Horário de expediente',
        },
        form: {
          importOldMessagesEnable: 'Importar mensagens do aparelho',
          importOldMessages: 'Data de inicio da importação',
          importRecentMessages: 'Data de termino da importação',
          importAlreadyDone:
            'Este período já foi importado em {{date}}. Altere as datas para importar novamente.',
          closedTicketsPostImported: 'Encerrar tickets após importação',
          name: 'Nome',
          queueRedirection: 'Redirecionamento de Fila',
          queueRedirectionDesc:
            'Selecione uma fila para os contatos que não possuem fila serem redirecionados',
          default: 'Padrão',
          group: 'Permitir grupos',
          timeSendQueue: 'Tempo em minutos para redirecionar para fila',
          importAlert:
            'ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens',
          importMax30Days: 'O período de importação não pode exceder 30 dias',
          importMax30DaysHint: 'Máximo 30 dias entre as datas',
          allowGroup: 'Permitir grupos',
          groupAsTicket: 'Tratar grupos como ticket',
          maxUseBotQueues: 'Reenviar menu de fila x vezes',
          timeUseBotQueues: 'Reenviar menu de fila a cada x minutos',
          expiresTicket: 'Encerrar chats abertos após x minutos',
          expiresTicketNPS: 'Encerrar chats aguardando avaliação após x minutos',
          maxUseBotQueuesNPS: 'Quantidade máxima de vezes que a avaliaçao vai ser enviada',
          closeLastMessageOptions1: 'Do atendente/Cliente',
          closeLastMessageOptions2: 'Do atendente',
          outOfHoursMessage: 'Mensagem de fora de expediente',
          greetingMessage: 'Mensagem de saudação',
          complationMessage: 'Mensagem de conclusão',
          lgpdLinkPrivacy: 'Link para política de privacidade',
          lgpdMessage: 'Mensagem de saudaçao LGPD',
          lgpdDeletedMessages: 'Ofuscar mensagem apagada pelo contato',
          lgpdSendMessage: 'Sempre solicitar confirmação do contato',
          ratingMessage: 'Mensagem de avaliaçao - Escala deve ser de 0 a 10',
          token: 'Token para integração externa',
          sendIdQueue: 'Fila',
          inactiveMessage: 'Mensagem de inatividade',
          timeInactiveMessage: 'Tempo em minutos para envio do aviso de inatividade',
          whenExpiresTicket: 'Encerrar chats abertos quando última mensagem for',
          expiresInactiveMessage: 'Mensagem de encerramento por inatividade',
          prompt: 'Prompt',
          collectiveVacationEnd: 'Data final',
          collectiveVacationStart: 'Data inicial',
          collectiveVacationMessage: 'Mensagem de férias coletivas',
          queueIdImportMessages: 'Fila para importar as mensagens',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        menuItem: {
          enabled: 'Habilitado',
          disabled: 'Desabilitado',
          minutes: 'minutos',
        },
        success: 'Conexão salvo com sucesso.',
        errorSendQueue:
          'Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos',
        errorExpiresNPS:
          'Informe o tempo de encerramento dos chats aguardando avaliação — obrigatório pois a conexão está configurada para avaliar atendimentos.',
        errorRatingMessage:
          'É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.',
        errorCollectiveVacationMessage:
          'Informe a mensagem de férias coletivas quando as datas estiverem preenchidas.',
        errorCollectiveVacationDates:
          'Informe data início e fim quando a mensagem de férias coletivas estiver preenchida.',
        errorCollectiveVacationDateOrder:
          'A data final deve ser igual ou posterior à data inicial.',
        outOfHoursConnectionNote:
          'Mensagem da conexão (horário geral). O fora de expediente por departamento é configurado em Departamentos.',
        sections: {
          menuIntro: 'Menu de departamentos',
          menuIntroDesc:
            'Texto enviado junto com a lista numerada antes do contato escolher um departamento.',
          singleQueueMenuNote:
            'Com apenas um departamento nesta conexão, o menu numerado não aparece. Configure a mensagem após a escolha em Atendimento, se aplicável.',
          queueAfterChoice: 'Mensagem após escolha do departamento',
          queueAfterChoiceDesc:
            'Enviada logo depois que o contato digita o número do departamento no menu. Uma frase por departamento selecionado acima.',
          queueAfterChoicePlaceholder: 'Ex.: Você entrou no Suporte. Aguarde um momento.',
          ticketClose: 'Encerramento do ticket',
          ticketCloseDesc:
            'Mensagem única desta conexão, enviada ao contato quando o ticket é finalizado (não é por departamento).',
        },
        help: {
          whatItDoes: 'O que faz',
          inPractice: 'Na prática',
          ariaHelp: 'Ver explicação',
          queuesText:
            'Define quais departamentos ficam disponíveis nesta conexão. Quando o contato envia mensagem sem departamento, o sistema exibe o menu numerado com essas opções.',
          queuesPractice:
            'A ordem de exibição segue o campo "Ordem da fila" de cada departamento. Só entram no menu os departamentos selecionados aqui.',
          maxUseBotQueuesText:
            'Limita quantas vezes o menu de departamentos será reenviado se o contato não escolher uma opção válida.',
          maxUseBotQueuesPractice: 'Use 0 para reenviar sem limite de vezes.',
          timeUseBotQueuesText:
            'Intervalo em minutos entre cada reenvio automático do menu de departamentos.',
          timeUseBotQueuesPractice: 'Use 0 para desativar o reenvio automático.',
          sendIdQueueText:
            'Departamento de destino para tickets pendentes que continuam sem departamento após o tempo de redirecionamento.',
          sendIdQueuePractice:
            'Só tem efeito quando o tempo de redirecionamento também estiver preenchido com valor maior que 0.',
          timeSendQueueText:
            'Minutos de espera antes de mover automaticamente tickets pendentes sem departamento para o departamento de redirecionamento.',
          timeSendQueuePractice: 'Com 0, o redirecionamento automático fica desativado.',
          expiresTicketText:
            'Encerra automaticamente tickets em atendimento aberto após o tempo informado sem interação.',
          expiresTicketPractice:
            'O tempo pode somar o aviso de inatividade, se configurado. Use 0 para não encerrar por tempo.',
          whenExpiresTicketText:
            'Define de quem deve ser a última mensagem para contar o tempo de inatividade antes do encerramento.',
          whenExpiresTicketPractice:
            '"Do atendente/Cliente" considera qualquer mensagem; "Do atendente" só conta quando a última mensagem foi enviada pelo atendente.',
          timeInactiveMessageText:
            'Minutos sem interação antes de enviar o aviso de inatividade ao contato.',
          timeInactiveMessagePractice:
            'Requer mensagem de inatividade preenchida. O tempo é somado ao de encerramento automático.',
          inactiveMessageText:
            'Mensagem enviada ao contato quando o ticket fica inativo pelo tempo configurado.',
          inactiveMessagePractice:
            'É um aviso antes do encerramento. Só é disparado uma vez por ticket inativo.',
          expiresInactiveMessageText:
            'Mensagem enviada ao contato no momento em que o ticket é encerrado por inatividade.',
          expiresInactiveMessagePractice:
            'Usada junto com o tempo de encerramento. Deixe em branco para encerrar sem mensagem final.',
          greetingMessageText:
            'Texto enviado junto ao menu de departamentos quando o contato inicia atendimento sem fila definida. Também pode ser usado na saudação ao aceitar ticket, conforme configuração da empresa.',
          greetingMessagePractice:
            'Obrigatório quando a conexão tem mais de um departamento (aba Atendimento). Aceita variáveis como {nome} e {numero}.',
          greetingAttachmentText:
            'Imagem ou vídeo enviado junto com a mensagem de saudação no menu de departamentos.',
          greetingAttachmentPractice:
            'O upload é feito ao salvar a conexão. Formatos aceitos: imagem e vídeo.',
          complationMessageText:
            'Mensagem automática enviada ao contato quando o ticket é encerrado (após avaliação NPS, se estiver ativa).',
          complationMessagePractice:
            'Não é enviada em grupos. Aceita variáveis do contato, como {nome}.',
          outOfHoursMessageText:
            'Resposta automática quando o contato escreve fora do horário de expediente desta conexão.',
          outOfHoursMessagePractice:
            'Requer horário configurado na aba "Horário de expediente" e tipo de expediente por empresa ou conexão. É diferente da mensagem de fora de expediente do departamento.',
          collectiveVacationMessageText:
            'Resposta automática enviada a qualquer contato que escrever durante o período de férias coletivas.',
          collectiveVacationMessagePractice:
            'Interrompe o fluxo normal de atendimento no período. Informe também data início e fim.',
          collectiveVacationStartText:
            'Primeiro dia em que a mensagem de férias coletivas passa a ser enviada.',
          collectiveVacationStartPractice:
            'Obrigatório quando a mensagem de férias estiver preenchida.',
          collectiveVacationEndText:
            'Último dia em que a mensagem de férias coletivas permanece ativa.',
          collectiveVacationEndPractice: 'Deve ser igual ou posterior à data inicial.',
        },
      },
      qrCode: {
        message: 'Leia o QrCode para iniciar a sessão',
      },
      contacts: {
        title: 'Contatos',
        toasts: {
          deleted: 'Contato excluído com sucesso!',
        },
        searchPlaceholder: 'Pesquisar...',
        confirmationModal: {
          deleteTitle: 'Deletar ',
          importTitlte: 'Importar contatos',
          exportContact: 'Exportar contatos',
          deleteMessage:
            'Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.',
          blockContact: 'Tem certeza que deseja bloquear este contato?',
          unblockContact: 'Tem certeza que deseja desbloquear este contato?',
          importMessage: 'Deseja importar todos os contatos do telefone?',
          importChat: 'Importar Conversas',
          wantImport: 'Deseja importar todas as conversas do telefone?',
        },
        buttons: {
          import: 'Importar Contatos',
          add: 'Novo contato',
          export: 'Exportar Contato',
        },
        table: {
          name: 'Nome',
          whatsapp: 'Conexão',
          email: 'Email',
          actions: 'Ações',
          lastMessage: 'Última Mensagem',
        },
        menu: {
          importYourPhone: 'Importar do aparelho padrão',
          importToExcel: 'Importar / Exportar do Excel',
        },
      },
      forwardMessage: {
        text: 'Encaminhada',
      },
      forwardMessageModal: {
        title: 'Encaminhar mensagem',
        buttons: {
          ok: 'Encaminhar',
        },
      },
      promptModal: {
        form: {
          name: 'Nome',
          prompt: 'Prompt',
          voice: 'Voz',
          max_tokens: 'Máximo de Tokens na resposta',
          temperature: 'Temperatura',
          apikey: 'API Key',
          max_messages: 'Máximo de mensagens no Histórico',
          voiceKey: 'Chave da API de Voz',
          voiceRegion: 'Região de Voz',
        },
        success: 'Agente IA salvo com sucesso!',
        title: {
          add: 'Adicionar agente IA',
          edit: 'Editar agente IA',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          save: 'Salvar agente',
        },
        subtitle: 'Configure seu agente em poucos passos e publique com seguranca.',
        tabs: {
          start: 'Inicio',
          tools: 'Ferramentas',
          knowledge: 'Conhecimento',
        },
        sections: {
          agentName: 'Nome do agente',
          serviceQueue: 'Setor de atendimento',
          mainPrompt: 'Prompt principal',
          aiConfig: 'Configuração de IA',
          tools: 'Ferramentas disponíveis para este agente IA',
          knowledge: 'Base de conhecimento',
        },
        quickStart: {
          title: 'Inicio rapido',
          description: 'Comece pelo basico para publicar seu agente sem confusao.',
          step1: 'Defina nome e setor',
          step2: 'Escreva o prompt principal',
          step3: 'Escolha modelo de IA',
        },
        hints: {
          agentName: 'Escolha um nome curto e facil de identificar.',
          serviceQueue: 'Defina em qual fila esse agente vai atuar (obrigatorio).',
          mainPrompt: 'Escreva o comportamento do agente, tom de voz e limites de resposta.',
          aiConfigByok: 'Escolha o provedor, modelo e configure o acesso de IA para esse agente.',
          aiConfigPlatform:
            'Escolha o provedor e modelo de IA. Os créditos do plano serão usados automaticamente.',
          noProvider:
            'Nenhum provedor de IA configurado. Solicite ao administrador que configure as chaves de API na seção de Créditos de IA.',
          platformCredits: 'Este agente usará créditos do plano para processar as respostas de IA.',
          tools:
            'Marque somente as ferramentas que este agente deve usar. Funções sensíveis (ex.: integrações externas ou criação de empresa) ficam desabilitadas até você ativar explicitamente.',
          knowledge:
            'Envie PDFs, imagens ou cadastre links para fornecer contexto adicional à IA. Esses materiais serão usados para enriquecer as respostas do agente.',
        },
        aiProvider: {
          label: 'Provedor de IA',
          model: 'Modelo',
          mode: 'Modo de uso de IA',
          modeAuto: 'Automático',
          modeByok: 'Minha chave API',
          modePlatform: 'Créditos do plano',
          modeAutoDesc: 'Usa créditos do plano quando disponíveis, senão a chave própria',
          modeByokDesc: 'Usa somente a chave configurada neste agente',
          modePlatformDesc: 'Usa somente créditos da plataforma, ignora chave própria',
          freeLabel: 'Grátis',
        },
        tools: {
          sensitive: 'Sensível',
          active: 'Ativa para este agente',
          inactive: 'Desativada',
        },
        knowledge: {
          addImage: 'Adicionar imagem',
          uploading: 'Enviando...',
          selectImage: 'Selecionar imagem',
          addLink: 'Adicionar link',
          linkTitle: 'Título do link',
          linkUrl: 'URL (https://...)',
          addButton: 'Adicionar',
          resources: 'Recursos adicionados',
          empty:
            'Nenhum conteúdo cadastrado ainda. Adicione arquivos ou links para disponibilizar conhecimento à IA.',
          defaultTitle: 'Link salvo',
          imageLabel: 'Imagem',
          linkLabel: 'Link',
          open: 'Abrir',
          copyLink: 'Copiar link',
          remove: 'Remover',
        },
        validation: {
          queueRequired: 'Selecione o setor de atendimento',
          promptRequired: 'Informe o prompt principal',
          apiKeyRequired: 'Informe a API Key',
          providerRequired: 'Selecione o provedor de IA',
          providerUnavailable: 'Provedor não disponível — chave de API não configurada',
          modelRequired: 'Selecione o modelo de IA',
        },
        toasts: {
          linkCopied: 'Link copiado!',
          copyError: 'Não foi possível copiar o link.',
          uploadError: 'Não foi possível enviar o arquivo.',
          fileAdded: 'Arquivo adicionado à base de conhecimento!',
          linkTitleRequired: 'Informe o título e o link.',
          invalidUrl: 'Informe um link válido (https://...).',
          linkAdded: 'Link adicionado à base de conhecimento!',
        },
      },
      prompts: {
        title: 'Agentes IA',
        table: {
          name: 'Nome',
          queue: 'Setor/Fila',
          max_tokens: 'Máximo Tokens Resposta',
          actions: 'Ações',
          agent: 'Agente',
          sector: 'Setor',
          maxTokens: 'Max tokens',
          tools: 'Ferramentas',
          noTools: 'Nenhuma',
          noQueue: 'Sem fila',
          edit: 'Editar',
          editAgent: 'Editar agente',
          delete: 'Excluir',
          deleteAgent: 'Excluir agente',
        },
        page: {
          title: 'Agentes de IA',
          subtitle: 'Configure agentes inteligentes para responder clientes',
          search: 'Buscar agente IA...',
          addButton: 'Novo agente',
          addTooltip: 'Adicionar agente IA',
          agentCount_one: 'agente IA configurado',
          agentCount_other: 'agentes IA configurados',
          expandedAriaLabel: 'Detalhes do agente {{name}}',
          rowsPerPage: 'Linhas:',
          displayedRows: '{{from}}-{{to}} de {{count}}',
        },
        messages: {
          noOpenAiPermission:
            'Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.',
        },
        expandedPanel: {
          sections: {
            agentAndSector: 'Agente e setor',
            modelAndParams: 'Modelo e parâmetros',
            mainPrompt: 'Prompt principal',
            toolsAndKnowledge: 'Ferramentas e conhecimento',
            keysHidden: 'Chaves (ocultas)',
            tokenUsage: 'Uso de tokens',
            registry: 'Registro',
          },
          fields: {
            id: 'ID',
            name: 'Nome',
            companyId: 'Empresa (ID)',
            sector: 'Setor',
            queueId: 'Fila (ID)',
            provider: 'Provedor',
            model: 'Modelo',
            temperature: 'Temperatura',
            maxTokens: 'Max. tokens',
            maxMessages: 'Max. mensagens',
            voice: 'Voz',
            text: 'Texto',
            activeTools: 'Ferramentas ativas',
            kbItems: 'Itens na base',
            apiKey: 'API (IA)',
            voiceKey: 'Voz (key)',
            voiceRegion: 'Região voz',
            promptTokens: 'Prompt',
            completionTokens: 'Conclusão',
            totalTokens: 'Total',
            createdAt: 'Criado em',
            updatedAt: 'Atualizado em',
          },
          yes: 'Sim',
          no: 'Não',
          none: 'Nenhuma',
          notConfigured: 'Não configurada',
          hiddenShort: '•••••••• (oculto)',
          hiddenPartial: '{{start}}…{{end}} (oculto)',
          providers: {
            openai: 'OpenAI',
            gemini: 'Google Gemini',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida!',
        },
        buttons: {
          add: 'Adicionar agente IA',
        },
      },
      iaWorkflow: {
        page: {
          title: 'Workflow de IA',
          subtitle: 'Configure a IA orquestradora e conecte agentes especializados',
        },
        sections: {
          data: 'Dados do workflow',
          orchestrator: 'Agente IA orquestrador',
          agents: 'Agentes conectados',
        },
        form: {
          name: 'Nome do workflow',
          nameHelp: 'Ex.: Atendimento SDR, Suporte N2',
          description: 'Descrição',
          orchestratorHint: 'Selecione o agente IA que será o cérebro/orquestrador:',
          agentAlias: 'Apelido do agente',
          agentAliasHelp: 'Nome exibido na execução do workflow',
          selectAgentIa: 'Selecionar agente IA',
          searchAgent: 'Buscar agente',
          searchAgentIa: 'Buscar agente IA',
        },
        buttons: {
          addAgent: 'Adicionar agente',
          saveWorkflow: 'Salvar workflow',
          saving: 'Salvando...',
          close: 'Fechar',
          cancel: 'Cancelar',
          saveChanges: 'Salvar alterações',
        },
        modal: {
          editTitle: 'Editar agente',
          addTitle: 'Adicionar agente',
          subtitle: 'Configure o agente e selecione um agente IA',
        },
        messages: {
          noAgents: 'Nenhum agente adicionado ainda.',
          loading: 'Carregando workflow de IA...',
          saveSuccess: 'Workflow salvo com sucesso',
          noPermission: 'Você não tem permissão para acessar este editor.',
        },
        validation: {
          nameRequired: 'Informe um nome para o workflow.',
          nameMinLength: 'Use pelo menos 3 caracteres no nome.',
          orchestratorRequired: 'Selecione um agente IA orquestrador.',
          agentsRequired: 'Adicione pelo menos um agente ao workflow.',
          agentsDuplicate: 'Existem agentes duplicados com o mesmo agente IA e apelido.',
          agentIaRequired: 'Selecione um agente IA.',
          agentAliasRequired: 'Informe um apelido para o agente.',
          agentAliasExists: 'Já existe um agente com esse agente IA e apelido.',
        },
      },
      contactModal: {
        title: {
          add: 'Adicionar contato',
          edit: 'Editar contato',
        },
        form: {
          mainInfo: 'Dados do contato',
          extraInfo: 'Informações adicionais',
          name: 'Nome',
          number: 'Número do Whatsapp',
          email: 'Email',
          extraName: 'Nome do campo',
          extraValue: 'Valor',
          chatBotContact: 'Desabilitar chatbot',
          termsLGDP: 'Termos LGPD aceito em:',
          whatsapp: 'Conexão Origem: ',
        },
        buttons: {
          addExtraInfo: 'Adicionar informação',
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Contato salvo com sucesso.',
      },
      flowbuilderModal: {
        flowNotIdPhrase: 'Fluxo padrão',
      },
      queueModal: {
        title: {
          queueData: 'Dados da fila',
          text: 'Horários de atendimento',
          add: 'Adicionar fila',
          edit: 'Editar fila',
          confirmationDelete: 'Tem certeza? Todas as opções de integrações serão deletadas.',
        },
        tabs: {
          expediente: 'Expediente',
        },
        expediente: {
          title: 'Expediente do departamento',
          subtitle:
            'Defina quando este departamento atende e a mensagem automática enviada fora desse horário.',
          schedulesTitle: 'Horários de atendimento',
          messageTitle: 'Mensagem fora de expediente',
          messageHint:
            'Enviada quando o contato escolhe este departamento fora do horário configurado acima.',
          saveButton: 'Salvar expediente',
          savedOnCreate: 'Horários e mensagem serão aplicados ao criar o departamento.',
        },
        greetingAfterChoiceHint:
          'Enviada automaticamente quando o contato digita o número deste departamento no menu da conexão.',
        form: {
          name: 'Nome',
          color: 'Cor',
          orderQueue: 'Ordem da fila (Bot)',
          rotate: 'Rodízio',
          timeRotate: 'Tempo de Rodízio',
          greetingMessage: 'Mensagem de saudação',
          greetingMessageAfterChoice: 'Mensagem após escolha do departamento',
          complationMessage: 'Mensagem de conclusão',
          outOfHoursMessage: 'Mensagem de fora de expediente',
          token: 'Token',
          integrationId: 'Integração',
          fileListId: 'Lista de arquivos',
          closeTicket: 'Fechar ticket',
          queueType: 'Tipo de menu',
          message: 'Mensagem de retorno',
          queue: 'Fila para transferência',
          integration: 'Integração',
          file: 'Lista de arquivos',
        },
        help: {
          whatItDoes: 'O que faz',
          inPractice: 'Na prática',
          ariaHelp: 'Ver explicação',
          rotateText:
            'Distribui automaticamente os tickets pendentes deste departamento entre os atendentes vinculados. Um ticket sem atendente é atribuído a um atendente online; se ele não der andamento dentro do tempo de rodízio, o ticket é repassado a outro.',
          rotatePractice:
            'Só considera atendentes online vinculados ao departamento. O "Tempo de rodízio" define quanto esperar antes de repassar um ticket parado.',
          orderText:
            'Define a posição deste departamento no menu que o bot mostra ao contato no WhatsApp quando a conexão tem mais de um departamento. Números menores aparecem primeiro.',
          orderPractice:
            'O contato escolhe o departamento pelo número exibido. Use valores distintos e sequenciais (1, 2, 3…) para manter a ordem previsível.',
          schedulesText:
            'Define os turnos de atendimento deste departamento. Use Turno A e Turno B para intervalos no mesmo dia (ex.: manhã e tarde).',
          schedulesPractice:
            'Deixe os campos vazios em um dia para considerá-lo fechado. O expediente só vale quando em Configurações o agendamento está como "Gerenciamento por Fila".',
          outOfHoursText:
            'Resposta automática enviada ao contato que escolhe este departamento fora do horário de expediente definido acima.',
          outOfHoursPractice:
            'Aceita variáveis do contato, como {nome}. Se ficar em branco, nenhuma mensagem é enviada fora do horário.',
          greetingMessageText:
            'Feedback enviado ao contato logo após ele escolher este departamento no menu numerado da conexão.',
          greetingMessagePractice:
            'Ex.: "Você entrou no Suporte. Em breve um atendente fala com você." Aceita variáveis como {nome}. Se ficar em branco, nada é enviado após a escolha.',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        bot: {
          title: 'Opções',
          toolTipTitle: 'Adicione opções para construir um chatbot',
          toolTip:
            'Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante',
          selectOption: 'Selecione uma opção',
          text: 'Texto',
          attendent: 'Atendente',
          queue: 'Fila',
          integration: 'Integração',
          file: 'Arquivo',
          toolTipMessageTitle: 'A mensagem é obrigatória para seguir ao próximo nível',
          toolTipMessageContent: 'A mensagem é obrigatória para seguir ao próximo nível',
          selectUser: 'Selecione um Usuário',
          selectQueue: 'Selecione uma Fila',
          selectIntegration: 'Selecione uma Integração',
          addOptions: 'Adicionar opções',
        },
        serviceHours: {
          dayWeek: 'Dia da semana',
          startTimeA: 'Hora Inicial - Turno A',
          endTimeA: 'Hora Final - Turno A',
          startTimeB: 'Hora Inicial - Turno B',
          endTimeB: 'Hora Final - Turno B',
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
      },
      queueIntegrationModal: {
        title: {
          add: 'Adicionar projeto',
          edit: 'Editar projeto',
        },
        form: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nome',
          projectName: 'Nome do Projeto',
          language: 'Linguagem',
          jsonContent: 'JsonContent',
          urlN8N: 'URL',
          typebotSlug: 'Typebot - Slug',
          typebotExpires: 'Tempo em minutos para expirar uma conversa',
          typebotKeywordFinish: 'Palavra para finalizar o ticket',
          typebotKeywordRestart: 'Palavra para reiniciar o fluxo',
          typebotRestartMessage: 'Mensagem ao reiniciar a conversa',
          typebotUnknownMessage: 'Mensagem de opção inválida',
          typebotDelayMessage: 'Intervalo (ms) entre mensagens',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          test: 'Testar Bot',
        },
        messages: {
          testSuccess: 'Integração testada com sucesso!',
          addSuccess: 'Integração adicionada com sucesso.',
          editSuccess: 'Integração editada com sucesso.',
        },
      },
      userModal: {
        warning: 'Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!',
        title: {
          add: 'Adicionar usuário',
          edit: 'Editar usuário',
          myProfile: 'Meu perfil',
          updateImage: 'Atualizar imagem',
          removeImage: 'Excluir imagem',
        },
        myProfileSubtitle: 'Dados gerais, filas e configurações da sua conta.',
        form: {
          name: 'Nome',
          email: 'Email',
          password: 'Senha',
          farewellMessage: 'Mensagem de despedida',
          profile: 'Perfil',
          profileUser: 'Usuário',
          profileAdmin: 'Administrador',
          profileOwner: 'Proprietário',
          profileSuperAdmin: 'Super Admin',
          startWork: 'Inicio de trabalho',
          endWork: 'Fim de trabalho',
          whatsapp: 'Conexão Padrão',
          allTicketEnable: 'Habilitado',
          allTicketDisable: 'Desabilitado',
          allTicket: 'Visualizar chamados sem fila',
          allowGroup: 'Permitir Grupos',
          defaultMenuOpen: 'Aberto',
          defaultMenuClosed: 'Fechado',
          defaultMenu: 'Menu padrão',
          allHistoric: 'Ver conversas de outras filas',
          allHistoricEnabled: 'Habilitado',
          allHistoricDisabled: 'Desabilitado',
          allUserChat: 'Ver conversas de outros usuários',
          userClosePendingTicket: 'Permitir fechar tickets pendentes',
          showDashboard: 'Ver Dashboard',
          allowRealTime: 'Ver Painel de Atendimentos',
          allowConnections: 'Permitir ações nas conexões',
        },
        tabs: {
          general: 'Geral',
          permissions: 'Permissões',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          addImage: 'Adicionar Imagem',
          editImage: 'Editar Imagem',
        },
        success: 'Usuário salvo com sucesso.',
        permissionsSaveError: 'Usuário salvo, mas houve um erro ao salvar as permissões de acesso.',
      },
      companyModal: {
        title: {
          add: 'Adicionar empresa',
          edit: 'Editar empresa',
        },
        form: {
          name: 'Nome',
          email: 'Email',
          passwordDefault: 'Senha',
          numberAttendants: 'Usuários',
          numberConections: 'Conexões',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Empresa salvo com sucesso.',
      },
      scheduleModal: {
        title: {
          add: 'Novo Agendamento',
          edit: 'Editar Agendamento',
        },
        form: {
          body: 'Mensagem',
          contact: 'Contato',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          assinar: 'Enviar Assinatura',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          close: 'Fechar',
          addSchedule: 'Adicionar agendamento',
        },
        success: 'Agendamento salvo com sucesso.',
        confirmationModal: {
          deleteTitle: 'Excluir anexo',
          deleteMessage: 'Tem certeza que deseja excluir este anexo?',
        },
        toasts: {
          deleted: 'Anexo excluído com sucesso.',
        },
      },
      contactTagPicker: {
        title: 'Adicionar tag',
        subtitle: 'Clique para selecionar ou remover',
        searchPlaceholder: 'Buscar tag...',
        close: 'Fechar',
        empty: 'Nenhuma tag encontrada',
        emptyNoTags: 'Você ainda não tem etiquetas cadastradas.',
        emptyNoTagsHint: 'Crie etiquetas para organizar e filtrar seus contatos.',
        emptySearch: 'Nenhuma etiqueta corresponde à sua busca.',
        quickCreateOpen: 'Nova etiqueta',
        quickCreateTitle: 'Nova etiqueta',
        quickCreateNameLabel: 'Nome da etiqueta',
        quickCreateMinLength: 'Mínimo de 3 caracteres.',
        quickCreateCancel: 'Cancelar',
        quickCreateColorLabel: 'Cor',
        quickCreateAction: 'Criar e aplicar',
        quickCreateColorOption: 'Cor {{color}}',
        colors: {
          teal: 'verde-azulado',
          blue: 'azul',
          violet: 'roxo',
          pink: 'rosa',
          red: 'vermelho',
          orange: 'laranja',
          green: 'verde',
          slate: 'cinza',
        },
      },
      tagModal: {
        title: {
          add: 'Nova Tag',
          edit: 'Editar Tag',
          addKanban: 'Novo Quadro',
          editKanban: 'Editar Quadro',
        },
        form: {
          name: 'Nome',
          color: 'Cor',
          timeLane: 'Horas até redirecionar',
          timeLaneHelper:
            'Após esse intervalo (em horas), o ticket pode ser movido para o quadro de destino ao lado.',
          nextLaneId: 'Quadro de destino',
          greetingMessageLane: 'Mensagem de saudação',
          greetingMessageLaneHelper: 'Texto exibido no contexto deste quadro no Kanban.',
          rollbackLaneId: 'Quadro ao retomar',
          rollbackLaneHelper:
            'Quadro para o qual o ticket retorna quando o atendimento for retomado.',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Tag salva com sucesso.',
        successKanban: 'Quadro salvo com sucesso.',
      },
      fileModal: {
        title: {
          add: 'Adicionar lista de arquivos',
          edit: 'Editar lista de arquivos',
        },
        buttons: {
          okAdd: 'Salvar',
          okEdit: 'Editar',
          cancel: 'Cancelar',
          fileOptions: 'Adicionar arquivo',
        },
        form: {
          name: 'Nome da lista de arquivos',
          message: 'Detalhes da lista',
          fileOptions: 'Lista de arquivos',
          extraName: 'Mensagem para enviar com arquivo',
          extraValue: 'Valor da opção',
        },
        success: 'Lista de arquivos salva com sucesso!',
      },
      chat: {
        noTicketMessage: 'Selecione um ticket para começar a conversar.',
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: '⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️',
          titleFileList: 'Lista de arquivo(s)',
        },
      },
      chatInternal: {
        new: 'Novo Chat Interno',
        widget: {
          hubKicker: 'Chat empresa',
          hubHeadline: 'Olá! Em que podemos ajudar?',
          hubSubline: 'Costumamos responder em poucos minutos.',
          searchPlaceholder: 'Buscar conversas…',
          emptyList: 'Nenhuma conversa encontrada.',
          emptyThread: 'Nenhuma mensagem ainda. Envie a primeira.',
          newConversation: 'Nova conversa',
          typeMessage: 'Digite uma mensagem…',
        },
        header: {
          back: 'Voltar à lista',
          subtitle: 'Criado por {{name}} · ',
          subtitleOwnerOnly: 'Criado por {{name}}',
          subtitleDateOnly: 'Criado em ',
        },
        media: {
          attach: 'Anexar arquivo (uma mídia por envio)',
          recordAudio: 'Gravar áudio',
          recordStop: 'Parar gravação',
          recordCancel: 'Cancelar gravação',
          recordConfirm: 'Enviar áudio gravado',
          send: 'Enviar mensagem',
          recordError: 'Não foi possível usar o microfone. Verifique a permissão do navegador.',
          recordUnsupported: 'Seu navegador não suporta gravação de áudio aqui.',
          recordingPlaceholder: 'Gravando áudio…',
          attachmentPreview: {
            title: 'Anexo',
            remove: 'Remover',
            send: 'Enviar',
            imageAlt: 'Pré-visualização da imagem',
            videoLabel: 'Pré-visualização do vídeo',
            audioHint: 'Arquivo de áudio',
            fileHint: 'Pré-visualização não disponível para este tipo de arquivo',
          },
        },
        modal: {
          conversation: 'Conversa',
          title: 'Título',
          titleRequired: 'Informe um título para a conversa.',
          filterUsers: 'Filtro por Usuários',
          cancel: 'Fechar',
          save: 'Salvar',
        },
        modalDelete: {
          title: 'Excluir Conversa',
          message: 'Esta ação não pode ser revertida, confirmar?',
        },
        deleteMessage: 'Excluir mensagem',
        deleteMessageConfirm: 'Excluir esta mensagem para todos? Esta ação não pode ser desfeita.',
        deleteModal: {
          title: 'Excluir mensagem',
          question: 'Tem certeza que deseja excluir esta mensagem?',
          subtext: 'Esta ação não pode ser desfeita.',
          confirm: 'Excluir',
          cancel: 'Cancelar',
          previewAudio: 'Áudio',
          previewImage: 'Foto',
          previewVideo: 'Vídeo',
          previewDocument: 'Documento',
        },
      },
      ticketsManager: {
        questionCloseTicket: 'VOCÊ DESEJA FECHAR TODOS OS TICKETS?',
        yes: 'SIM',
        not: 'NÃO',
        buttons: {
          newTicket: 'Novo',
          resolveAll: 'Resolver Todos',
          close: 'Fechar',
          new: 'Novo',
        },
      },
      ticketsQueueSelect: {
        placeholder: 'Filas',
      },
      tickets: {
        inbox: {
          closedAllTickets: 'Fechar todos os tickets?',
          closedAll: 'Fechar Todos',
          newTicket: 'Novo Ticket',
          yes: 'SIM',
          no: 'NÃO',
          open: 'Abertos',
          resolverd: 'Resolvidos',
        },
        toasts: {
          deleted: 'O atendimento que você estava foi deletado.',
        },
        notification: {
          message: 'Mensagem de',
        },
        tabs: {
          open: { title: 'Abertas' },
          closed: { title: 'Resolvidos' },
          search: { title: 'Busca' },
        },
        search: {
          placeholder: 'Buscar atendimento e mensagens',
          filterConections: 'Filtro por Conexão',
          filterConectionsOptions: {
            open: 'Aberto',
            closed: 'Fechado',
            pending: 'Pendente',
          },
          filterUsers: 'Filtro por Usuarios',
          filterContacts: 'Filtro por Contatos',
          ticketsPerPage: 'Tickets por página',
        },
        buttons: {
          showAll: 'Todos',
          returnQueue: 'Devolver a Fila',
          scredule: 'Agendamento',
          deleteTicket: 'Deletar Ticket',
          quickmessageflash: 'Mensagem Rápida',
        },
        closedTicket: {
          closedMessage: 'Fechar Ticket Com Mensagem de Despedida',
          closedNotMessage: 'Fechar Ticket Sem Mensagem de Despedida',
        },
        confirmationModal: {
          deleteTitle: 'Excluir ticket',
          deleteMessage: 'Deseja realmente excluir este ticket?',
          closeTitle: 'Fechar ticket',
          closeMessage: 'Deseja realmente fechar este ticket?',
          ignoreTitle: 'Ignorar ticket',
          ignoreMessage: 'Deseja realmente ignorar este ticket?',
        },
      },
      transferTicketModal: {
        title: 'Transferir Ticket',
        subtitle: 'Escolha o atendente (opcional) e o departamento de destino.',
        close: 'Fechar',
        fieldLabel: 'Digite para buscar usuários',
        fieldQueueLabel: 'Departamento (fila)',
        fieldQueuePlaceholder: 'Selecione um departamento (fila)',
        fieldWhatsapp: 'Selecione um whatsapp',
        noOptions: 'Nenhum usuário encontrado com esse nome',
        msgTransfer: 'Observações - mensagem interna, não vai para o cliente',
        buttons: {
          ok: 'Transferir',
          cancel: 'Cancelar',
        },
      },
      ticketsList: {
        called: 'Chamado',
        today: 'Hoje',
        missedCall: 'Chamada de voz/vídeo perdida às',
        pendingHeader: 'Aguardando',
        assignedHeader: 'Atendendo',
        groupingHeader: 'Grupos',
        noTicketsTitle: 'Nenhum ticket encontrado',
        noTicketsMessage:
          'Nenhum ticket encontrado nesta aba com os filtros ou termo de busca atuais.',
        noQueue: 'Sem Fila',
        buttons: {
          accept: 'Aceitar',
          cancel: 'Cancelar',
          start: 'iniciar',
          closed: 'Fechar',
          reopen: 'Reabrir',
          transfer: 'Transferir',
          ignore: 'Ignorar',
          exportAsPDF: 'Exportar para PDF',
          kanbanActions: 'Opções de Kanban',
        },
        acceptModal: {
          title: 'Aceitar Chat',
          queue: 'Departamento (fila)',
        },
      },
      newTicketModal: {
        title: 'Criar Ticket',
        fieldLabel: 'Digite para pesquisar o contato',
        add: 'Adicionar',
        buttons: {
          ok: 'Salvar',
          cancel: 'Cancelar',
        },
      },
      SendContactModal: {
        title: 'Enviar contato',
        fieldLabel: 'Digite para pesquisar o contato',
        add: 'Adicionar',
        buttons: {
          ok: 'Enviar',
          cancel: 'Cancelar',
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: 'Dashboard',
          connections: 'Conexões',
          chatsTempoReal: 'Painel',
          tickets: 'Atendimentos',
          quickMessages: 'Respostas rápidas',
          contacts: 'Contatos',
          queues: 'Departamentos (fila)',
          tags: 'Tags',
          administration: 'Administração',
          companies: 'Empresas',
          users: 'Usuários',
          settings: 'Configurações',
          files: 'Lista de arquivos',
          helps: 'Ajuda',
          messagesAPI: 'API',
          schedules: 'Agendamentos',
          campaigns: 'Campanhas',
          annoucements: 'Informativos',
          chats: 'Chat Interno',
          financeiro: 'Financeiro',
          queueIntegration: 'Integrações',
          version: 'Versão',
          kanban: 'Kanban',
          prompts: 'Agende IA',
          allConnections: 'Gerenciar conexões',
          reports: 'Relatórios',
          management: 'Gerência',
        },
        appBar: {
          user: {
            profile: 'Perfil',
            logout: 'Sair',
            message: 'Olá',
            messageEnd: 'seja bem-vindo a',
            active: 'Ativo até',
            goodMorning: 'Oi,',
            myName: 'meu nome é',
            continuity: 'e darei continuidade em seu atendimento.',
            virtualAssistant: 'Assistente Virtual',
            token: 'Token inválido, por favor entre em contato com o administrador da plataforma.',
          },
          message: {
            location: 'Localização',
            contact: 'Contato',
          },
          notRegister: 'Nenhum registro',
          refresh: 'Atualizar',
        },
      },
      languages: {
        undefined: 'Idioma',
        'pt-BR': 'Português',
        es: 'Español',
        en: 'English',
      },
      messagesAPI: {
        title: 'API',
        textMessage: {
          number: 'Número',
          body: 'Mensagem',
          token: 'Token cadastrado',
          userId: 'ID do usuário/atendente',
          queueId: 'ID da Fila',
        },
        mediaMessage: {
          number: 'Número',
          body: 'Nome do arquivo',
          media: 'Arquivo',
          token: 'Token cadastrado',
        },
        API: {
          title: 'Documentação para envio de mensagens',
          methods: {
            title: 'Métodos de Envío',
            messagesText: 'Mensagens de Texto',
            messagesMidia: 'Mensagens com Arquivos',
          },
          instructions: {
            title: 'Instruções',
            comments: 'Observações Importantes',
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              'O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:',
            codeCountry: 'Código do País',
            code: 'DDD',
            number: 'Número',
          },
          text: {
            title: '1. Mensagens de Texto',
            instructions:
              'Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:',
          },
          media: {
            title: '2. Mensagens com Arquivo',
            instructions:
              'Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:',
          },
        },
      },
      notifications: {
        noTickets: 'Nenhuma notificação.',
      },
      runFlow: {
        title: 'Executar fluxo',
        searchPlaceholder: 'Buscar fluxo…',
        empty: 'Nenhum fluxo ativo disponível',
        noMatch: 'Nenhum fluxo encontrado',
        toasts: {
          success: 'Fluxo disparado',
        },
        errors: {
          forbidden: 'Você não tem permissão para executar fluxos',
        },
        buttons: {
          execute: 'Executar',
          executing: 'Executando…',
          cancel: 'Cancelar',
        },
      },
      quickMessages: {
        title: 'Respostas Rápidas',
        searchPlaceholder: 'Pesquisar...',
        noAttachment: 'Sem anexo',
        pickerEmpty: 'Nenhuma mensagem rápida cadastrada.',
        noTextPreview: '(sem texto)',
        confirmationModal: {
          deleteTitle: 'Exclusão',
          deleteMessage: 'Esta ação é irreversível! Deseja prosseguir?',
        },
        buttons: {
          add: 'Adicionar',
          attach: 'Arquivo',
          cancel: 'Cancelar',
          edit: 'Editar',
          recordAudio: 'Gravar áudio',
          finishRecording: 'Concluir',
          discardRecording: 'Descartar',
        },
        toasts: {
          success: 'Atalho adicionado com sucesso!',
          deleted: 'Atalho removido com sucesso!',
          fileTypeNotAllowed: 'Tipo de arquivo não permitido.',
          fileTooLarge: 'Arquivo muito grande. O limite é de 16 MB.',
          micBlocked:
            'Microfone bloqueado no navegador. Clique no cadeado ao lado da URL e permita o uso do microfone.',
          micError: 'Não foi possível acessar o microfone.',
          recordingTooShort: 'Gravação muito curta.',
          recordingError: 'Não foi possível processar a gravação.',
          sendingAttachment: 'Enviando anexo...',
          sendError: 'Não foi possível enviar a resposta rápida.',
        },
        dialog: {
          title: 'Mensagem Rápida',
          shortcode: 'Atalho',
          message: 'Resposta',
          save: 'Salvar',
          cancel: 'Cancelar',
          geral: 'Edição por outros',
          add: 'Adicionar',
          edit: 'Editar',
          visao: 'Visível para o time',
          sharingSectionTitle: 'Compartilhamento',
          sharingSectionHint:
            'Defina quem pode usar esta resposta no atendimento e quem pode alterá-la.',
          visaoHelper: 'Ativo: outros atendentes veem e podem inserir esta resposta nas conversas.',
          visaoOptionYes: 'Sim, compartilhar com o time',
          visaoOptionNo: 'Não, apenas eu',
          geralHelper:
            'Ativo: qualquer usuário com acesso pode editar o texto e o atalho. Inativo: só o criador edita.',
          geralHelperDisabled: 'Disponível quando a resposta estiver visível para o time.',
          geralOptionYes: 'Sim, qualquer um pode editar',
          geralOptionNo: 'Não, só o criador edita',
          subtitle: 'Crie atalhos de mensagem para o time.',
          insertEmoji: 'Inserir emoji',
          removeAttachment: 'Remover arquivo',
        },
        table: {
          shortcode: 'Atalho',
          message: 'Mensagem',
          actions: 'Ações',
          mediaName: 'Nome do Arquivo',
          status: 'Status',
          editable: 'Editar',
          viewOnly: 'Somente visualização',
        },
      },
      contactLists: {
        title: 'Listas segmentadas (tags)',
        table: {
          name: 'Nome',
          contacts: 'Contatos',
          actions: 'Ações',
        },
        buttons: {
          add: 'Nova lista de contatos',
        },
        dialog: {
          name: 'Nome',
          company: 'Empresa',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          deleted: 'Registro excluído',
          updated: 'Lista atualizada.',
          created: 'Lista criada.',
        },
      },
      contactListItems: {
        title: 'Contatos',
        searchPlaceholder: 'Pesquisa',
        buttons: {
          add: 'Novo',
          lists: 'Listas',
          import: 'Importar',
        },
        dialog: {
          name: 'Nome',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        table: {
          name: 'Nome',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          actions: 'Ações',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
          importMessage: 'Deseja importar os contatos desta planilha? ',
          importTitlte: 'Importar',
        },
        toasts: {
          deleted: 'Registro excluído',
        },
      },

      kanban: {
        title: 'Kanban',
        searchPlaceholder: 'Pesquisa',
        subMenus: {
          list: 'Painel',
          tags: 'Quadros',
        },
      },

      campaigns: {
        title: 'Campanhas',
        massDispatchTitle: 'Disparo em massa',
        searchPlaceholder: 'Pesquisa',
        subMenus: {
          list: 'Listagem',
          listContacts: 'Lista de contatos',
          settings: 'Configurações',
        },
        settings: {
          randomInterval: 'Intervalo Randômico de Disparo',
          noBreak: 'Sem Intervalo',
          intervalGapAfter: 'Intervalo maior após',
          undefined: 'Não definido',
          messages: 'mensagens',
          laggerTriggerRange: 'Intervalo de disparo maior',
          addVar: 'Adicionar variável',
          save: 'Salvar',
          close: 'Fechar',
          add: 'Adicionar',
          shortcut: 'Atalho',
          content: 'Conteúdo',
        },
        buttons: {
          add: 'Nova campanha',
          addPhrase: 'Nova campanha por frase',
          contactLists: 'Listas de Contatos',
        },
        table: {
          name: 'Nome',
          whatsapp: 'Conexão',
          contactList: 'Lista de Contatos',
          option: 'Nenhuma',
          disabled: 'Desabilitada',
          enabled: 'Habilitada',
          status: 'Status',
          scheduledAt: 'Agendamento',
          completedAt: 'Concluída',
          confirmation: 'Confirmação',
          actions: 'Ações',
        },
        dialog: {
          new: 'Nova Campanha',
          update: 'Editar Campanha',
          readonly: 'Apenas Visualização',
          help: 'Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.',
          modalSubtitleNew: 'Configure o disparo em massa e visualize a prévia no celular.',
          modalSubtitleEdit: 'Ajuste mensagens, público-alvo, conexões e agendamento.',
          form: {
            name: 'Nome',
            message1: 'Mensagem principal (variação 1)',
            message2: 'Mensagem principal (variação 2)',
            message3: 'Mensagem principal (variação 3)',
            message4: 'Mensagem principal (variação 4)',
            message5: 'Mensagem principal (variação 5)',
            confirmationMessage1: 'Mensagem de confirmação (variação 1)',
            confirmationMessage2: 'Mensagem de confirmação (variação 2)',
            confirmationMessage3: 'Mensagem de confirmação (variação 3)',
            confirmationMessage4: 'Mensagem de confirmação (variação 4)',
            confirmationMessage5: 'Mensagem de confirmação (variação 5)',
            messagePlaceholder: 'Conteúdo da mensagem',
            whatsapp: 'Conexão',
            status: 'Status',
            scheduledAt: 'Agendamento',
            confirmation: 'Confirmação',
            confirmationHelp:
              'Com a confirmação habilitada o disparo vira duas etapas: o contato recebe apenas a mensagem de confirmação e a mensagem principal só sai depois que ele responder.',
            messagesTitle: 'Mensagens',
            messagesHelp:
              'Cada contato recebe UMA das variações preenchidas, sorteada aleatoriamente. Elas não são enviadas em sequência — preencher mais de uma serve para variar o texto e reduzir o risco de bloqueio.',
            messagesHelpConfirmation:
              'O contato recebe apenas a mensagem de confirmação. A mensagem principal é enviada assim que ele responder — qualquer resposta serve. Sem resposta, a mensagem principal não é enviada. As variações de cada etapa são sorteadas de forma independente: a variação 1 da confirmação não está ligada à variação 1 da principal.',
            stageConfirmation: '1. Confirmação (enviada no disparo)',
            stageMain: '2. Mensagem principal (após a resposta)',
            variationTab: 'Variação',
            previewAfterReply: 'Esta mensagem só é enviada depois que o contato responder.',
            confirmationRules: 'Regras da confirmação',
            confirmationRulesHelp:
              'Definem por quanto tempo a campanha espera a resposta e o que conta como confirmação. Quem não confirmar dentro do prazo não recebe a mensagem principal.',
            confirmationTimeoutHours: 'Prazo para responder',
            confirmationTimeoutHoursHelp: 'Em horas, de 1 a 720. Padrão: 24.',
            confirmationMode: 'O que confirma',
            confirmationModeAny: 'Qualquer resposta',
            confirmationModeKeywords: 'Somente as palavras abaixo',
            confirmationKeywords: 'Palavras de confirmação',
            confirmationKeywordsPlaceholder: 'Digite e tecle vírgula ou Enter',
            confirmationKeywordsHelp:
              'Cada palavra vira um chip. Até 20 palavras; a comparação ignora maiúsculas, acentos e pontuação.',
            confirmationOptOutHelp:
              'Em qualquer um dos modos, respostas de recusa (não, parar, sair, "pare de mandar") encerram o disparo para aquele contato: a mensagem principal não é enviada.',
            contactList: 'Lista de Contato',
            tagList: 'Contatos por tag',
            targetAudience: 'Público-alvo',
            targetAudienceHelp:
              'Escolha uma lista de contatos existente ou selecione uma tag para gerar a lista com os contatos vinculados a ela. São exibidas apenas tags que possuem contatos.',
            statusTicket: 'Status do Ticket',
            openTicketStatus: 'Aberto',
            pendingTicketStatus: 'Pendente',
            closedTicketStatus: 'Fechado',
            enabledOpenTicket: 'Habilitado',
            disabledOpenTicket: 'Desabilitado',
            openTicket: 'Abrir ticket',
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar Disparos',
            restart: 'Reiniciar Disparos',
            close: 'Fechar',
            attach: 'Arquivo',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          success: 'Operação realizada com sucesso',
          cancel: 'Campanha cancelada',
          restart: 'Campanha reiniciada',
          deleted: 'Registro excluído',
        },
      },
      campaignReport: {
        title: 'Relatório de Campanha',
        back: 'Voltar',
        inactive: 'Inativa',
        scheduled: 'Programada',
        process: 'Em Andamento',
        cancelled: 'Cancelada',
        finished: 'Finalizada',
        finishedPartial: 'Finalizada parcialmente',
        campaign: 'Campanha',
        validContacts: 'Contatos Válidos',
        refresh: 'Atualizar',
        retry: 'Tentar novamente',
        loadErrorTitle: 'Não foi possível carregar o relatório',
        loadErrorHelp: 'Verifique sua conexão e tente novamente.',
        ofContacts: 'de {{total}} contatos válidos',
        progressHelp: 'Contatos que já receberam a mensagem da campanha.',
        progressHelpConfirmation:
          'Contatos que responderam à confirmação e receberam a mensagem principal. Quem não confirma dentro do prazo não entra nesta conta.',
        validContactsCaption: 'Base do disparo',
        details: 'Detalhes da campanha',
        confirmationRule: 'Regra de confirmação',
        confirmationsRequested: 'Confirmações Solicitadas',
        confirmations: 'Confirmações',
        deliver: 'Entregues',
        deliverMainMessage: 'Mensagem principal entregue',
        awaitingConfirmation: 'Aguardando confirmação',
        withoutConfirmation: 'Não confirmaram',
        connection: 'Conexão',
        contactLists: 'Lista de Contatos',
        schedule: 'Agendamento',
        conclusion: 'Conclusão',
      },
      announcements: {
        title: 'Informativos',
        searchPlaceholder: 'Pesquisa',
        active: 'Ativo',
        inactive: 'Inativo',
        buttons: {
          add: 'Informativo',
          contactLists: 'Listas de Informativos',
        },
        table: {
          priority: 'Prioridade',
          title: 'Title',
          text: 'Texto',
          mediaName: 'Arquivo',
          status: 'Status',
          actions: 'Ações',
        },
        dialog: {
          edit: 'Edição de Informativo',
          add: 'Informativo',
          update: 'Editar Informativo',
          readonly: 'Apenas Visualização',
          form: {
            priority: 'Prioridade',
            title: 'Title',
            text: 'Texto',
            mediaPath: 'Arquivo',
            status: 'Status',
            high: 'Alta',
            medium: 'Média',
            low: 'Baixa',
            active: 'Ativo',
            inactive: 'Inativo',
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar',
            close: 'Fechar',
            attach: 'Arquivo',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          success: 'Operação realizada com sucesso',
          deleted: 'Registro excluído',
        },
      },
      campaignsConfig: {
        title: 'Configurações de Campanhas',
      },
      queues: {
        title: 'Departamentos',
        table: {
          name: 'Nome',
          color: 'Cor',
          greeting: 'Mensagem de saudação',
          orderQueue: 'Ordenação da fila (bot)',
          actions: 'Ações',
          ID: 'ID',
        },
        buttons: {
          add: 'Adicionar fila',
        },
        toasts: {
          success: 'Fila salva com sucesso',
          deleted: 'Fila exclu[ida com sucesso',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.',
        },
      },
      queue: {
        queueData: 'Dados',
      },
      queueSelect: {
        inputLabel: 'Departamento (fila)',
        inputLabelRO: 'Filas somente leitura',
        withoutQueue: 'Sem fila',
      },
      reports: {
        title: 'Relatórios de Atendimentos',
        table: {
          id: 'Ticket',
          user: 'Usuário',
          dateOpen: 'Data Abertura',
          dateClose: 'Data Fechamento',
          NPS: 'NPS',
          status: 'Status',
          whatsapp: 'Conexão',
          queue: 'Fila',
          actions: 'Ações',
          lastMessage: 'Últ. Mensagem',
          contact: 'Cliente',
          supportTime: 'Tempo de Atendimento',
        },
        buttons: {
          filter: 'Filtrar',
          onlyRated: 'Apenas Avaliados',
        },
        searchPlaceholder: 'Pesquisar...',
      },
      queueIntegration: {
        title: 'Integrações',
        table: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nome',
          projectName: 'Nome do Projeto',
          language: 'Linguagem',
          lastUpdate: 'Ultima atualização',
          actions: 'Ações',
        },
        buttons: {
          add: 'Adicionar Projeto',
        },
        searchPlaceholder: 'Pesquisar...',
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas',
        },
      },
      users: {
        title: 'Usuários',
        table: {
          status: 'Status',
          name: 'Nome',
          email: 'Email',
          profile: 'Perfil',
          profiles: {
            admin: 'Administrador',
            user: 'Usuário',
            owner: 'Proprietário',
            superAdmin: 'Super Admin',
          },
          startWork: 'Inicio de trabalho',
          endWork: 'Fim de trabalho',
          actions: 'Ações',
          ID: 'ID',
        },
        buttons: {
          add: 'Adicionar usuário',
        },
        toasts: {
          deleted: 'Usuário excluído com sucesso.',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.',
        },
      },
      compaies: {
        title: 'Empresas',
        table: {
          ID: 'ID',
          status: 'Ativo',
          name: 'Nome',
          email: 'Email',
          password: 'Senha',
          phone: 'Telefone',
          plan: 'Plano',
          active: 'Ativo',
          numberAttendants: 'Atendentes',
          numberConections: 'Conexões',
          value: 'Valor',
          namePlan: 'Nome Plano',
          numberQueues: 'Filas',
          useCampaigns: 'Campanhas',
          useSchedules: 'Mensagens agendadas',
          useInternalChat: 'Chat Interno',
          useFacebook: 'Facebook',
          useInstagram: 'Instagram',
          useTelegram: 'Telegram',
          useWhatsappOfficial: 'Whatsapp Oficial',
          useOpenAi: 'Agentes de IA',
          useTasks: 'Tarefas',
          useProducts: 'Produtos',
          useAppointments: 'Agenda',
          useMcp: 'Conexões MCP',
          useIntegrations: 'Integrações',
          useClients: 'Clientes',
          createdAt: 'Criada Em',
          dueDate: 'Vencimento',
          lastLogin: 'Ult. Login',
          actions: 'Ações',
          money: 'R$',
          noPlan: 'Sem plano',
          yes: 'Sim',
          no: 'Não',
          document: 'CNPJ/CPF',
          recurrence: 'Recorrência',
          monthly: 'Mensal',
          bimonthly: 'Bimestral',
          quarterly: 'Trimestral',
          semester: 'Semestral',
          yearly: 'Anual',
          clear: 'Limpar',
          delete: 'Excluir',
          user: 'Usuário',
          save: 'Salvar',
        },
        buttons: {
          add: 'Adicionar empresa',
        },
        toasts: {
          deleted: 'Empresa excluído com sucesso.',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.',
        },
      },
      plans: {
        form: {
          name: 'Nome',
          users: 'Usuários',
          connections: 'Conexões',
          campaigns: 'Campanhas',
          schedules: 'Agendamentos',
          enabled: 'Habilitadas',
          disabled: 'Desabilitadas',
          clear: 'Cancelar',
          delete: 'Excluir',
          save: 'Salvar',
          yes: 'Sim',
          no: 'Não',
          money: 'R$',
          public: 'Público',
          planName: 'Nome do plano',
          visibility: 'Visibilidade',
          recurrence: 'Recorrência',
          publicOption: 'Público',
          privateOption: 'Privado',
          queues: 'Filas',
          amount: 'Valor',
          allowByok: 'Permitir chave própria (BYOK)',
          allowPlatformCredits: 'Permitir créditos da plataforma',
          includedCredits: 'Créditos de IA incluídos por período',
        },
        sections: {
          config: 'Configuração',
          limits: 'Limites e valor',
          resources: 'Recursos disponíveis',
          ai: 'Inteligência Artificial',
        },
        grid: {
          empty: 'Nenhum plano cadastrado',
          emptyHelp: 'Clique em "Novo plano" para começar',
          users: 'usuários',
          connections: 'conexões',
          queues: 'filas',
          byok: 'BYOK',
          editBtn: 'Editar plano',
          viewBtn: 'Ver plano',
          system: 'Padrão sistema',
          publicTag: 'Público',
          privateTag: 'Privado',
        },
        messages: {
          systemPlanTitle: 'Plano padrão do sistema',
          systemPlanWarning:
            'Este plano não pode ser editado nem excluído. Crie um plano novo para ofertas personalizadas.',
          addTitle: 'Novo plano',
          readonlyTitle: 'Plano (somente leitura)',
          editTitle: 'Editar plano',
          loadError: 'Não foi possível carregar a lista de registros',
          systemLocked: 'Este plano é padrão do sistema e não pode ser alterado.',
          success: 'Operação realizada com sucesso!',
          minCharge: 'Valor mínimo da cobrança em BRL não atingido. Ajuste o valor do plano.',
          operationError:
            'Não foi possível realizar a operação. Verifique se já existe um plano com o mesmo nome ou se os campos foram preenchidos corretamente',
          deleteSystemPlan: 'Este plano é padrão do sistema e não pode ser excluído.',
          deletePlanDefault: 'O plano padrão não pode ser excluído.',
          hasCompanies: 'Este plano possui empresas vinculadas e não pode ser excluído.',
          hasInvoices: 'Este plano possui faturas vinculadas e não pode ser excluído.',
          deleteFailed: 'Não foi possível realizar a operação',
        },
        modal: {
          deleteTitle: 'Exclusão de Registro',
          deleteConfirm: 'Deseja realmente excluir esse registro?',
          addNew: 'Novo plano',
        },
      },
      helps: {
        title: 'Central de Ajuda',
        settings: {
          codeVideo: 'Código do Video',
          description: 'Descrição',
          clear: 'Limpar',
          delete: 'Excluir',
          save: 'Salvar',
        },
      },
      schedules: {
        title: 'Agendamentos',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir este Agendamento?',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        table: {
          contact: 'Contato',
          body: 'Mensagem',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          status: 'Status',
          actions: 'Ações',
        },
        buttons: {
          add: 'Novo Agendamento',
        },
        toasts: {
          deleted: 'Agendamento excluído com sucesso.',
        },
      },
      metaCustomEvents: {
        hint: 'A Meta aceita qualquer nome de evento. Cadastre aqui os seus para reusar nas automações sem digitar de novo — nome diferente a cada disparo fragmenta os dados no Gerenciador de Eventos.',
        add: 'Novo evento',
        addTooltip: 'Cadastrar um evento personalizado',
        editTooltip: 'Editar evento',
        deleteTooltip: 'Excluir evento',
        empty: 'Nenhum evento personalizado cadastrado.',
        deleted: 'Evento excluído.',
        status: { active: 'Ativo', inactive: 'Inativo' },
        table: { name: 'Nome', description: 'Descrição', status: 'Situação', actions: 'Ações' },
        confirmDelete: {
          title: 'Excluir evento',
          message:
            'O evento "{{name}}" será removido. As automações que usam ele param de enviar. Deseja continuar?',
        },
        modal: {
          titleAdd: 'Novo evento personalizado',
          titleEdit: 'Editar evento personalizado',
          subtitle: 'O nome vai exatamente assim para o Meta',
          name: 'Nome do evento',
          nameHelp:
            'Sem espaço nem acento, começando por letra. Ex.: OrcamentoAprovado, VisitaAgendada.',
          description: 'Descrição (opcional)',
          descriptionHelp: 'Só para você lembrar do que se trata. Não é enviado ao Meta.',
          isActive: 'Disponível nas automações',
          cancel: 'Cancelar',
          add: 'Cadastrar',
          save: 'Salvar',
          created: 'Evento cadastrado.',
          updated: 'Evento atualizado.',
          validation: {
            required: 'Obrigatório',
            name: 'Use letras, números e underscore, começando por letra',
          },
        },
      },
      metaReport: {
        filterStatus: 'Situação',
        allStatuses: 'Todas',
        empty: 'Nenhum evento registrado ainda.',
        rowsPerPage: 'Linhas:',
        table: {
          date: 'Data',
          event: 'Evento',
          contact: 'Contato',
          value: 'Valor',
          pixel: 'Pixel',
          status: 'Situação',
          reason: 'Motivo',
        },
        status: {
          sent: 'Enviado',
          pending: 'Na fila',
          failed: 'Recusado',
          skipped_no_identity: 'Sem dados',
          skipped_app_inactive: 'App inativo',
        },
      },
      metaPixel: {
        title: 'Pixel do Meta',
        tabs: { pixels: 'Pixels', customEvents: 'Eventos personalizados', report: 'Relatório' },
        subtitle: 'Envie eventos de conversão do CRM para os seus anúncios',
        add: 'Novo pixel',
        addTooltip: 'Cadastrar um novo pixel do Meta',
        editTooltip: 'Editar pixel',
        deleteTooltip: 'Excluir pixel',
        testTooltip: 'Enviar um evento de teste',
        testDisabledTooltip: 'Cadastre o código de evento de teste no pixel para poder testar',
        empty: 'Nenhum pixel cadastrado ainda.',
        deleted: 'Pixel excluído.',
        status: { active: 'Ativo', inactive: 'Inativo' },
        table: {
          name: 'Nome',
          pixelId: 'ID do pixel',
          token: 'Token',
          currency: 'Moeda',
          status: 'Situação',
          actions: 'Ações',
        },
        confirmDelete: {
          title: 'Excluir pixel',
          message:
            'O pixel "{{name}}" será removido e as automações que usam ele param de enviar eventos. Deseja continuar?',
        },
        modal: {
          titleAdd: 'Novo pixel do Meta',
          titleEdit: 'Editar pixel do Meta',
          subtitle: 'Os dados ficam no Events Manager da sua conta',
          name: 'Nome',
          nameHelp: 'Só para você identificar, ex.: "Loja SP".',
          pixelId: 'ID do pixel',
          currency: 'Moeda',
          token: 'Token da Conversions API',
          tokenHelp:
            'Events Manager → o dataset → Configurações → Conversions API → Gerar token de acesso.',
          tokenHelpEdit: 'Deixe em branco para manter o token atual.',
          tokenSaved: 'Token configurado · {{preview}}',
          tokenReplace: 'Trocar token (opcional)',
          testEventCode: 'Código de evento de teste (opcional)',
          testEventCodeHelp:
            'Events Manager → aba Testar eventos. Usado apenas no botão de teste, nunca nos envios reais.',
          isActive: 'Pixel ativo',
          cancel: 'Cancelar',
          add: 'Cadastrar',
          save: 'Salvar',
          created: 'Pixel cadastrado.',
          updated: 'Pixel atualizado.',
          validation: {
            required: 'Obrigatório',
            nameShort: 'Mínimo 2 caracteres',
            pixelIdDigits: 'O ID do pixel deve conter apenas números',
            currency: 'Use 3 letras, ex.: BRL',
          },
        },
      },
      tags: {
        title: 'Tags',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir esta Tag?',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        table: {
          id: 'ID',
          name: 'Nome',
          kanban: 'Kanban',
          color: 'Cor',
          tickets: 'Registros Tags',
          contacts: 'Contatos',
          actions: 'Ações',
        },
        buttons: {
          add: 'Nova Tag',
        },
        toasts: {
          deleted: 'Tag excluído com sucesso.',
        },
      },

      tagsKanban: {
        title: 'Quadros',
        laneDefault: 'Em aberto',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir este Quadro?',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        table: {
          name: 'Nome',
          color: 'Cor',
          tickets: 'Tickets',
          actions: 'Ações',
        },
        buttons: {
          add: 'Novo Quadro',
        },
        toasts: {
          deleted: 'Quadro excluído com sucesso.',
        },
      },

      files: {
        title: 'Lista de arquivos',
        table: {
          name: 'Nome',
          contacts: 'Contatos',
          actions: 'Ação',
        },
        toasts: {
          deleted: 'Lista excluída com sucesso!',
          deletedAll: 'Todas as listas foram excluídas com sucesso!',
        },
        buttons: {
          add: 'Adicionar',
          deleteAll: 'Deletar Todos',
        },
        confirmationModal: {
          deleteTitle: 'Deletar',
          deleteAllTitle: 'Deletar Todos',
          deleteMessage: 'Tem certeza que deseja deletar esta lista?',
          deleteAllMessage: 'Tem certeza que deseja deletar todas as listas?',
        },
      },
      settings: {
        success: 'Configurações salvas com sucesso.',
        title: 'Configurações',
        tabs: {
          options: 'Opções',
          plans: 'Planos',
          helps: 'Ajuda',
        },
        settings: {
          userCreation: {
            name: 'Criação de usuário',
            options: {
              enabled: 'Ativado',
              disabled: 'Desativado',
            },
          },
          tabs: {
            options: 'Opções',
            schedules: 'Horários',
            plans: 'Planos',
            help: 'Ajuda',
          },
          options: {
            disabled: 'Desabilitado',
            enabled: 'Habilitado',
            updating: 'Atualizando...',
            creationCompanyUser: 'Criação de Empresa/Usuário',
            evaluations: 'Avaliações',
            officeScheduling: 'Agendamento de Expediente',
            queueManagement: 'Gerenciamento por Fila',
            companyManagement: 'Gerenciamento por Empresa',
            connectionManagement: 'Gerenciamento por Conexão',
            sendMsgTransfTicket: 'Enviar mensagem transferência de setor/atendente',
            checkMsgIsGroup: 'Ignorar Mensagens de Grupos',
            chatBotType: 'Tipo do Bot',
            userRandom: 'Escolher atendente aleatório',
            buttons: 'Botões',
            acceptCallWhatsapp: 'Informar que não aceita ligação no whatsapp?',
            sendSignMessage: 'Permite atendente escolher ENVIAR Assinatura',
            sendGreetingMessageOneQueues: 'Enviar saudação quando houver somente 1 fila',
            sendQueuePosition: 'Enviar mensagem com a posição da fila',
            sendFarewellWaitingTicket: 'Enviar mensagem de despedida no Aguardando',
            acceptAudioMessageContact: 'Aceita receber audio de todos contatos?',
            enableLGPD: 'Habilitar tratamento LGPD',
            requiredTag: 'Tag obrigatoria para fechar ticket',
            DirectTicketsToWallets: 'Mover automaticamente cliente para carteira',
            showNotificationPending: 'Mostrar notificação para tickets pendentes',
          },
          LGPD: {
            title: 'LGPD',
            welcome: 'Mensagem de boas vindas(LGPD)',
            linkLGPD: 'Link da política de privacidade',
            obfuscateMessageDelete: 'Ofuscar mensagem apagada',
            alwaysConsent: 'Sempre solicitar consentimento',
            obfuscatePhoneUser: 'Ofuscar número telefone para usuários',
            enabled: 'Habilitado',
            disabled: 'Desabilitado',
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: 'Atribuído à:',
          dialogRatingTitle: 'Deseja deixar uma avaliação de atendimento para o cliente?',
          dialogClosingTitle: 'Finalizando o atendimento com o cliente!',
          dialogRatingCancel: 'Com Mensagem de Despedida',
          dialogRatingSuccess: 'Resolver e Enviar Avaliação',
          dialogRatingWithoutFarewellMsg: 'SEM Mensagem de Despedida',
          ratingTitle: 'Escolha um menu de avaliação',
          notMessage: 'Nenhuma mensagem selecionada',
          amount: 'Valor de prospecção',
          buttons: {
            return: 'Retornar',
            resolve: 'Resolver',
            reopen: 'Reabrir',
            accept: 'Aceitar',
            rating: 'Enviar Avaliação',
            enableIntegration: 'Habilitar integração',
            disableIntegration: 'Desabilitar integração',
            logTicket: 'Logs do Ticket',
            requiredTag: 'Você deve atribuir uma tag antes de fechar o ticket.',
          },
        },
        reactionPicker: {
          moreEmojis: 'Mais emojis',
        },
        reactionDetail: {
          titleOne: '1 reação',
          titleMany: '{{count}} reações',
          you: 'Você',
          clickToRemove: 'Clique para remover',
          removeMyReaction: 'Remover minha reação',
          removeSessionFooterHint:
            'Use o link abaixo para remover a reação feita por esta conexão WhatsApp no painel.',
          badgeHint: 'Ver reações',
        },
      },
      messagesInput: {
        placeholderPrivateMessage: 'Digite uma mensagem ou aperte / para respostas rápidas',
        placeholderOpen: 'Digite uma mensagem ou aperte / para respostas rápidas',
        placeholderClosed: 'Reabra ou aceite esse ticket para enviar uma mensagem.',
        signMessage: 'Assinar',
        privateMessage: 'Mensagem Privada',
      },
      contactDrawer: {
        header: 'Dados do contato',
        buttons: {
          edit: 'Editar contato',
          block: 'Bloquear',
          unblock: 'Desbloquear',
        },
        extraInfo: 'Outras informações',
      },
      messageVariablesPicker: {
        label: 'Variáveis disponíveis',
        vars: {
          contactFirstName: 'Primeiro Nome',
          contactName: 'Nome',
          contactNumber: 'Número',
          user: 'Atendente',
          greeting: 'Saudação',
          protocolNumber: 'Protocolo',
          date: 'Data',
          hour: 'Hora',
          ticket_id: 'Nº do Chamado',
          queue: 'Setor',
          connection: 'Conexão',
        },
      },
      ticketOptionsMenu: {
        schedule: 'Agendamento',
        delete: 'Deletar',
        transfer: 'Transferir',
        registerAppointment: 'Observações do Contato',
        resolveWithNoFarewell: 'Finalizar sem despedida',
        acceptAudioMessage: 'Aceitar áudios do contato?',
        appointmentsModal: {
          title: 'Observações do Ticket',
          textarea: 'Observação',
          placeholder: 'Insira aqui a informação que deseja registrar',
        },
        confirmationModal: {
          title: 'Deletar o ticket do contato',
          titleFrom: 'do contato ',
          message: 'Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.',
        },
        buttons: {
          delete: 'Excluir',
          cancel: 'Cancelar',
        },
      },
      confirmationModal: {
        buttons: {
          confirm: 'Confirmar',
          cancel: 'Cancelar',
        },
      },
      messageInput: {
        tooltip: {
          signature: 'Habilitar/Desabilitar Assinatura',
          privateMessage: 'Habilitar/Desabilitar Mensagem Privada',
          meet: 'Enviar link para videoconferencia',
        },
        type: {
          attachFile: 'Anexar arquivo',
          imageVideo: 'Fotos e vídeos',
          cam: 'Câmera',
          document: 'Documento',
          contact: 'Contato',
          meet: 'Vídeo chamada',
          privateMessage: 'Mensagem privada',
          followUps: 'Follow-ups',
          scheduleMessage: 'Agendamento de mensagem',
          moreOptions: 'Mais opções',
          moreOptionsDetail: 'Mais opções (botões, lista, etc.)',
          quickMessages: 'Mensagens rápidas',
          signature: 'Assinatura (nome do atendente)',
          emojis: 'Emojis',
        },
        dropzone: {
          title: 'Solte para enviar',
          subtitle: 'Imagens, vídeos, áudios e documentos',
          subtitleSingle: 'Um arquivo por vez',
        },
      },
      messageOptionsMenu: {
        delete: 'Deletar',
        reply: 'Responder',
        edit: 'Editar',
        forward: 'Encaminhar',
        toForward: 'Encaminhar',
        talkTo: 'Conversar Com',
        copyMessage: 'Copiar mensagem',
        copySuccess: 'Mensagem copiada!',
        copyNoText: 'Esta mensagem não contém texto para copiar.',
        officialDeleteBlocked: 'A API Oficial do WhatsApp não permite apagar mensagens.',
        officialEditBlocked: 'A API Oficial do WhatsApp não permite editar mensagens.',
        confirmationModal: {
          title: 'Apagar mensagem?',
          message: 'Esta ação não pode ser revertida.',
        },
      },
      invoices: {
        table: {
          invoices: 'Faturas',
          details: 'Detalhes',
          users: 'Usuários',
          connections: 'Conexões',
          queue: 'Filas',
          value: 'Valor',
          expirationDate: 'Data Venc.',
          action: 'Ação',
        },
      },
      import: {
        page: {
          title: 'Importações',
          subtitle: 'Acompanhe as importações de histórico WhatsApp e Meta (Facebook/Instagram)',
        },
        buttons: {
          refresh: 'Atualizar',
          startMeta: 'Importar histórico (Meta)',
          backToConnections: 'Voltar às Conexões',
        },
        emptyState: 'Nenhuma importação encontrada',
        toasts: {
          started: 'Import iniciado',
          finished: 'Import finalizado',
        },
        metaModal: {
          title: 'Importar histórico (Meta)',
          hint: 'Se token estiver vazio, o backend usa o token salvo na conexão.',
          selectConnection: 'Selecione a conexão',
          selectConnectionRequired: 'Selecione uma conexão',
          loadingConnections: 'Carregando conexões...',
          noConnections: 'Nenhuma conexão Meta encontrada',
          pageIdRequired: 'Page ID é obrigatório',
          dateStart: 'Data início',
          dateEnd: 'Data fim',
        },
        banner: {
          importing: 'Importando histórico…',
          viewDetails: 'Ver detalhes',
        },
        tooltips: {
          whatsappAuto: 'WhatsApp importa automaticamente após conectar',
          metaRateLimit: 'Meta depende de permissões e rate limit',
        },
      },
      toastErrors: {
        generic: 'Não foi possível completar a operação. Tente novamente.',
        network: 'Falha de conexão. Verifique sua internet e tente novamente.',
        timeout: 'A requisição demorou demais. Tente novamente.',
        serverError: 'Erro no servidor ({{status}}). Tente novamente em instantes.',
        notFound: 'Recurso não encontrado. Verifique os dados e tente novamente.',
        forbidden: 'Você não tem permissão para realizar esta ação.',
        noPermissionToCreateContact:
          'Você não tem permissão para criar contatos. Solicite ao administrador para iniciar um atendimento com este contato.',
        httpError: 'Não foi possível completar a operação (erro {{status}}). Tente novamente.',
        noPagePermission: 'Esta empresa não possui permissão para acessar essa página!',
        whatsappIdInput: 'Informe o Whatsapp ID.',
        fileTooLarge5mb: 'Arquivo é muito grande! 5MB máximo',
        selectQueue: 'Selecione uma fila',
        selectFlow: 'Selecione um fluxo',
        ticketIdInput: 'Informe o Ticket ID.',
        enterMessageText: 'Digite o texto da mensagem',
        addAtLeastOneTag: 'Adicione pelo menos uma tag',
        selectKanbanTag: 'Selecione uma tag kanban',
        invoiceIdInput: 'Informe o Fatura ID.',
        userIdInput: 'Informe o User ID.',
        couldNotLoadRecords: 'Não foi possível carregar a lista de registros',
        invalidCpfCnpj: 'CPF/CNPJ inválido. Verifique o número informado.',
        errorUpdatingQueue: 'Erro ao atualizar fila.',
        fileTooLarge20mb: 'Arquivo é muito grande! 20MB máximo',
        errorLoadingData: 'Erro ao carregar dados',
        enterScheduleDateTime: 'Informe a data e o horário do agendamento.',
        dateTimeMustBeFuture: 'A data e o horário devem ser no futuro.',
        delayMin1Minute: 'O delay deve ser de pelo menos 1 minuto.',
        couldNotPerformOperation: 'Não foi possível realizar a operação',
        invalidPrimaryColor: 'Cor primária inválida. Use o formato HEX (#RGB ou #RRGGBB).',
        invalidColors: 'Existem cores inválidas. Use o formato HEX (#RGB ou #RRGGBB).',
        jsonInvalidQueueIds: 'JSON inválido em queueIds',
        tagIdToSearch: 'Informe o Tag ID para buscar um registro.',
        companyNotIdentified:
          'Empresa não identificada. Faça login novamente ou selecione uma empresa.',
        sourceAlreadyExists: 'Esta origem já existe.',
        sourceIsDefault:
          'Este nome já é uma origem padrão do sistema e aparece automaticamente. Escolha outro nome.',
        selectAtLeastOneTicket: 'Selecione pelo menos um ticket',
        selectTagInContacts: 'Selecione a tag (nos contatos)',
        enterTokenBeforeDownload: 'Informe o token antes de baixar a coleção.',
        invalidFlow: 'Fluxo inválido.',
        errorFetchingZip: 'Erro ao consultar CEP. Tente novamente.',
        nameRequiredArticle: 'O nome é obrigatório.',
        invalidEmail: 'Email inválido.',
        invalidCpf: 'CPF inválido.',
        invalidCnpj: 'CNPJ inválido.',
        enterNewPassword: 'Informe a nova senha.',
        passwordsDoNotMatch: 'As senhas não conferem.',
        companyCannotBeDeleted: 'Esta empresa não pode ser excluída.',
        couldNotSaveValue: 'Não foi possível salvar o valor.',
        fileExceeds20mb: 'Arquivo excede o limite de 20 MB',
        selectClient: 'Selecione um cliente.',
        enterInvoiceDescription: 'Informe a descrição da fatura.',
        enterInvoiceValue: 'Informe o valor da fatura.',
        enterDueDate: 'Informe a data de vencimento.',
        selectReferenceItem: 'Selecione o item referente ou limpe o tipo de referência.',
        errorSendingFile: 'Erro ao enviar arquivo. Tente novamente.',
        selectFile: 'Selecione um arquivo!',
        selectKanbanTagAlt: 'Selecione uma tag do Kanban',
        selectTag: 'Selecione uma tag',
        invalidHeadersJson: 'Headers JSON inválido',
        invalidBodyJson: 'Body JSON inválido',
        errorTestingApi: 'Erro ao testar API',
        enterRequestUrl: 'Informe a URL da requisição',
        addValidCondition: 'Adicione pelo menos uma condição válida',
        selectPipeline: 'Selecione um pipeline',
        selectStage: 'Selecione uma etapa',
        enterTitle: 'Informe um título',
        selectTargetStage: 'Selecione a etapa destino',
        enterLossReason: 'Informe o motivo da perda',
        errorStartingAuth: 'Erro ao iniciar autenticação',
        enterSpreadsheetId: 'Informe o ID da planilha',
        errorTestingConnection: 'Erro ao testar conexão',
        selectSpreadsheet: 'Selecione uma planilha',
        enterSheetName: 'Informe o nome da aba',
        addDataField: 'Adicione pelo menos um campo de dados',
        enterColumnAndValue: 'Informe a coluna e valor para busca',
        enterIntervalValue: 'Adicione o valor de intervalo (mínimo 1 segundo)',
        percentAboveZero: 'Defina um percentual acima de 0%',
        percentMax100: 'O percentual máximo é 100%',
        errorFetchingQueues: 'Erro ao buscar filas',
        selectWhatsappConnection: 'Selecione uma conexão WhatsApp',
        enterMessage: 'Digite a mensagem',
        invalidNumber: 'Número inválido. Use código do país + DDD + número (ex: 5585999999999)',
        errorReadingMessage: 'Erro ao ler mensagem. Feche e reabra o modal.',
        emptyMessageFields: 'Campos de mensagem vazio!',
        errorReadingInterval: 'Erro ao ler intervalo. Feche e reabra o modal.',
        intervalRange: 'Intervalo não pode ser 0 ou maior que 120!',
        deleteEmptyCards: 'Delete os cards vazios (Imagem, Arquivo, Audio e Video)',
        verifyTokenEmpty: 'O verify token não pode estar vazio.',
        folderNameRequired: 'O nome da pasta é obrigatório.',
        enterPaymentValue: 'Informe o valor do pagamento.',
        tokenRequiredWhenProviderActive: 'Token é obrigatório quando o provider está ativo.',
        couldNotRemoveAccess: 'Não foi possível remover o acesso',
        minChargeNotReached:
          'Valor mínimo da cobrança em BRL não atingido. Ajuste o valor do plano.',
        defaultPlanCannotBeDeleted: 'O plano padrão não pode ser excluído.',
        planHasCompanies: 'Este plano possui empresas vinculadas e não pode ser excluído.',
        planHasInvoices: 'Este plano possui faturas vinculadas e não pode ser excluído.',
        couldNotLoadServices: 'Não foi possível carregar a lista de serviços',
        enterProfessionalName: 'Informe o nome do profissional',
        errorSavingProfessional: 'Erro ao salvar profissional',
        couldNotSendFile: 'Não foi possível enviar o arquivo.',
        enterTitleAndLink: 'Informe o título e o link.',
        enterValidLink: 'Informe um link válido (https://...).',
        errorSavingService: 'Erro ao salvar serviço',
        errorUploadingIcon: 'Erro ao fazer upload do ícone.',
        onlyImages: 'Envie apenas imagens (PNG, JPG, WebP ou ICO).',
        noAccessPermission: 'Sem permissão para acessar!',
        onlyP12Files: 'Use somente arquivos em formato p12!',
        errorSendingCertificate: 'Erro ao enviar certificado. Tente novamente.',
        errorSavingTheme: 'Erro ao salvar o tema.',
        errorSavingColors: 'Erro ao salvar personalização de cores.',
        errorSavingEmailFooter: 'Erro ao salvar configurações do rodapé de e-mail.',
        serverResponseNoFilename: 'Resposta do servidor sem nome do arquivo.',
        errorUploadingImage: 'Erro ao fazer upload da imagem.',
        couldNotSaveBanner: 'Não foi possível salvar o banner',
        couldNotLoadBanners: 'Não foi possível carregar os banners',
        couldNotRemoveBanner: 'Não foi possível remover o banner',
        invalidValue: 'Valor inválido.',
        urlNotConfigured: 'URL não configurada.',
        errorLinkingClient: 'Erro ao vincular cliente.',
        couldNotSaveAdditionalInfo: 'Não foi possível salvar as informações adicionais.',
        couldNotUpdateChatbot: 'Não foi possível atualizar o chatbot.',
        couldNotUpdateAudioPermission: 'Não foi possível atualizar a permissão de áudio.',
        couldNotChangeContactStatus: 'Não foi possível alterar o status do contato.',
        titleRequired: 'Título é obrigatório',
        videoUrlRequired: 'URL do vídeo é obrigatória',
        descriptionMax300: 'Descrição deve ter no máximo 300 caracteres',
        errorAccessingMic: 'Erro ao acessar o microfone. Verifique as permissões.',
        recordingTooShort: 'Gravação muito curta. Grave por mais tempo.',
        errorSendingAudio: 'Erro ao enviar áudio. Tente novamente.',
        errorProcessingAudio: 'Erro ao processar áudio.',
        errorCancellingRecording: 'Erro ao cancelar gravação.',
        invalidContactForSend: 'Contato inválido para envio. Verifique nome e número.',
        errorUpdatingHubToken: 'Houve um erro ao tentar atualizar o token do Hub.',
        clientIdToSearch: 'Informe o Client ID para buscar um registro.',
        nameRequiredDot: 'Nome é obrigatório.',
        contactIdToSearch: 'Informe o Contact ID para buscar um registro.',
        clientValueDueRequired: 'Cliente, valor e data de vencimento são obrigatórios.',
        invoiceIdRequired: 'Fatura ID é obrigatório.',
        queueIdToSearch: 'Informe o Queue ID para buscar um registro.',
        dealIdToSearch: 'Informe o Negócio ID para buscar um registro.',
        productIdToSearch: 'Informe o Product ID para buscar um registro.',
        serviceIdToSearch: 'Informe o Service ID para buscar um registro.',
        taskIdToSearch: 'Informe o Task ID para buscar.',
        jsonInvalidTagIds: 'JSON inválido em tagIds',
        userOrQueueToTransfer: 'Informe User ID ou Queue ID para transferir.',
        jsonInvalidServiceIds: 'JSON inválido em serviceIds',
        userIdToSearch: 'Informe o User ID para buscar.',
        userIdAndServiceIds: 'Informe User ID e serviceIds.',
        userIdAndDateTime: 'Informe User ID e Data/Hora.',
        userIdAppointmentStatus: 'Informe User ID, Compromisso ID e Status.',
        couldNotGetPaymentLink: 'Não foi possível recuperar o link de pagamento.',
        couldNotCloseTickets: 'Não foi possível encerrar os tickets. Tente novamente.',
        mustAcceptTerms: 'Você precisa aceitar os termos para continuar.',
        enterPipelineName: 'Informe o nome do funil',
        onlyOneWonStage: 'Apenas 1 estágio pode ser marcado como Ganho',
        onlyOneLostStage: 'Apenas 1 estágio pode ser marcado como Perdido',
        exportedFileEmpty: 'Erro: O arquivo exportado está vazio',
        selectFileToImport: 'Selecione um arquivo para importar',
        fileMustBeJson: 'O arquivo deve ser do tipo JSON',
        configureQueueNodes:
          'Configure a fila em todos os nós "Direcionar para Fila" antes de salvar.',
        emailNotFound: 'Email não encontrado',
        saveIntegrationBeforeMapping: 'Salve a integração antes de mapear campos.',
        invalidTestJson: 'JSON de teste inválido.',
        selectTicketStatus: 'Selecione pelo menos um status de ticket',
        selectWeekday: 'Selecione pelo menos um dia da semana',
        profileNotFound: 'Perfil não encontrado.',
        imageMax1mb: 'Imagem deve ter no máximo 1 MB',
        nameRequired: 'Nome é obrigatório',
        selectUser: 'Selecione um usuário',
        couldNotGetGoogleLink: 'Não foi possível obter o link de conexão com o Google.',
        allowPopups: 'Permita pop-ups neste site para conectar o Google Calendar.',
      },
      toastSuccess: {
        // genéricos
        operation: 'Operação realizada com sucesso!',
        operationUpdated: 'Operação atualizada com sucesso.',
        saved: 'Salvo com sucesso.',
        settingsSaved: 'Configurações salvas!',
        settingsSavedSuccess: 'Configurações salvas com sucesso!',
        settingsReset: 'Configurações resetadas com sucesso!',
        configSaved: 'Configuração salva com sucesso.',
        configRemoved: 'Configuração removida.',
        copied: 'Copiado!',
        linkCopied: 'Link copiado!',
        redirectUriCopied: 'Redirect URI copiada!',
        webhookUrlCopied: 'URL do webhook copiada!',
        clickSaveToApply: 'Clique em salvar para registrar as alterações.',
        exported: 'Dados exportados com sucesso!',
        testSuccess: 'Teste realizado com sucesso!',
        connectionTested: 'Conexão testada com sucesso!',
        // arquivos / mídia
        fileSent: 'Arquivo enviado com sucesso!',
        filesSent: 'Arquivos enviados com sucesso.',
        fileRemoved: 'Arquivo removido com sucesso.',
        fileUploaded: 'Arquivo enviado.',
        fileAdded: 'Arquivo adicionado com sucesso!',
        contentAdded: 'Conteúdo adicionado com sucesso!',
        audioAdded: 'Áudio adicionado com sucesso!',
        videoAdded: 'Vídeo adicionado com sucesso!',
        videoCreated: 'Vídeo criado com sucesso!',
        videoUpdated: 'Vídeo atualizado com sucesso!',
        videoRemoved: 'Vídeo removido com sucesso!',
        folderCreated: 'Pasta criada com sucesso!',
        folderUpdated: 'Pasta atualizada com sucesso!',
        folderDeleted: 'Pasta excluída com sucesso!',
        knowledgeFileAdded: 'Arquivo adicionado à base de conhecimento!',
        knowledgeLinkAdded: 'Link adicionado à base de conhecimento!',
        // compromissos / agenda
        appointmentCreated: 'Compromisso criado com sucesso.',
        appointmentUpdated: 'Compromisso atualizado com sucesso.',
        appointmentDeleted: 'Compromisso excluído com sucesso.',
        appointmentCancelled: 'Compromisso cancelado. O convidado foi avisado por e-mail.',
        statusUpdated: 'Status atualizado.',
        scheduleCreated: 'Agenda criada com sucesso.',
        scheduleUpdated: 'Agenda atualizada com sucesso.',
        scheduleDeleted: 'Agenda excluída com sucesso.',
        googleCalendarLinked: 'Agenda vinculada ao seu Google Calendar com sucesso!',
        googleCalendarUnlinked: 'Google Calendar desvinculado da agenda.',
        googleCalendarDisconnected: 'Google Calendar desconectado com sucesso.',
        // tarefas / lixeira
        taskCreated: 'Tarefa criada com sucesso!',
        taskUpdated: 'Tarefa atualizada com sucesso!',
        taskRemoved: 'Tarefa removida.',
        taskRestored: 'Tarefa restaurada.',
        taskTrashed: 'Tarefa enviada para a lixeira.',
        taskDeletedPermanently: 'Tarefa excluída permanentemente.',
        opportunityRestored: '"{{title}}" restaurada com sucesso.',
        opportunityDeletedPermanently: 'Oportunidade excluída permanentemente.',
        // empresa / planos / apps
        companyCreated: 'Empresa cadastrada com sucesso!',
        planAccessRemoved: 'Acesso removido do plano.',
        appUpdated: 'App atualizado com sucesso.',
        appActivated: '{{app}} ativado.',
        appActivatedSuccess: '{{app}} ativado com sucesso!',
        appActivatedInvoicePaid: '{{app}} ativado — a fatura já estava paga.',
        appDeactivated: '{{app}} desativado.',
        appRequestCancelled: 'Solicitação de {{app}} cancelada.',
        paymentConfirmed: 'Pagamento confirmado.',
        appPaymentConfirmed: 'Pagamento confirmado — {{app}} liberado.',
        redirectingToPayment: 'Redirecionando para pagamento...',
        licenseRenewed: 'Sua licença foi renovada até {{date}}!',
        openPaymentTab: 'Abra a aba para concluir o pagamento.',
        // créditos de IA
        aiCreditsReversed: 'Créditos revertidos com sucesso.',
        aiCreditsRequestSent: 'Solicitação enviada. Aguarde aprovação do administrador.',
        aiCreditsRequestRejected: 'Solicitação recusada.',
        aiCreditsRequestCancelled: 'Solicitação cancelada.',
        aiCreditsRenewed: 'Créditos de IA renovados com sucesso!',
        aiCreditsAddedToAccount: 'Créditos adicionados à sua conta.',
        aiCreditsAdded: '{{credits}} créditos adicionados a {{company}}.',
        apiKeySaved: 'Chave {{label}} salva com sucesso.',
        apiKeyRemoved: 'Chave {{label}} removida.',
        markupUpdated: 'Markup atualizado.',
        modelCreated: 'Modelo cadastrado.',
        modelUpdated: 'Modelo atualizado.',
        modelDisabled: 'Modelo desativado.',
        // integrações / credenciais
        metaCredentialsSaved: 'Credenciais Facebook/Meta salvas com sucesso.',
        googleCredentialsSaved: 'Credenciais Google salvas com sucesso.',
        smtpSaved: 'Configurações SMTP salvas com sucesso.',
        openaiKeySaved: 'Chave OpenAI salva com sucesso.',
        whatsappOfficialSaved: 'Configuração WhatsApp Oficial salva com sucesso.',
        pixEfiSaved: 'Configuração Pix Efí salva com sucesso.',
        googleSheetsAuthenticated: 'Autenticado com Google Sheets!',
        integrationCreated: 'Integração criada.',
        integrationUpdated: 'Integração atualizada.',
        integrationRemoved: 'Integração removida.',
        mappingSaved: 'Mapeamento salvo.',
        baseUrlSaved: 'Copiado e URL base salva no backend!',
        // conexões / whatsapp
        whatsappConnected: 'WhatsApp conectado com sucesso!',
        // contatos / observações
        contactBlocked: 'Contato bloqueado.',
        contactUnblocked: 'Contato desbloqueado.',
        contactsExported: 'Planilha de contatos exportada.',
        contactsImportStarted: 'Importação iniciada. Os contatos vão aparecer em instantes.',
        contactsImportFinished:
          'Importação concluída: {{created}} criados, {{updated}} atualizados, {{unchanged}} sem alteração, {{skipped}} ignorados.',
        spreadsheetImported: 'Planilha importada.',
        noteAdded: 'Observação adicionada com sucesso!',
        noteDeleted: 'Observação excluída com sucesso!',
        clientCreated: 'Cliente criado com sucesso!',
        clientUpdated: 'Cliente atualizado com sucesso!',
        ticketValueUpdated: 'Valor do ticket atualizado!',
        queueUpdated: 'Fila atualizada!',
        allTicketsClosed: 'Todos os tickets {{status}} foram encerrados.',
        chatbotEnabled: 'Chatbot habilitado.',
        chatbotDisabled: 'Chatbot desabilitado.',
        contactActivated: 'Contato ativado com sucesso.',
        contactDeactivated: 'Contato desativado.',
        // CRM
        pipelineCreated: 'Funil criado!',
        pipelineSaved: 'Funil salvo!',
        pipelineDeleted: 'Funil excluído!',
        customFieldCreated: 'Campo criado.',
        customFieldUpdated: 'Campo atualizado.',
        customFieldRemoved: 'Campo removido.',
        crmSourceCreated: 'Origem criada!',
        crmSourceRemoved: 'Origem removida.',
        automationCreated: 'Automação criada.',
        automationUpdated: 'Automação atualizada.',
        automationRemoved: 'Automação removida.',
        triggerCreated: 'Disparo criado com sucesso.',
        triggerUpdated: 'Disparo atualizado com sucesso.',
        triggerRemoved: 'Disparo removido.',
        // produtos
        productSaved: 'Produto salvo com sucesso.',
        productCreated: 'Produto criado com sucesso.',
        productUpdated: 'Produto atualizado.',
        productDeleted: 'Produto excluído.',
        variantCreated: 'Variante criada.',
        variantUpdated: 'Variante atualizada.',
        variantDeleted: 'Variante excluída.',
        variantsGenerated: 'Variações geradas.',
        categoryCreated: 'Categoria criada.',
        categoryUpdated: 'Categoria atualizada.',
        categoryDeleted: 'Categoria excluída.',
        attributeCreated: 'Atributo criado.',
        attributeUpdated: 'Atributo atualizado.',
        attributeDeleted: 'Atributo excluído.',
        optionDeleted: 'Opção excluída.',
        // profissionais / serviços
        professionalCreated: 'Profissional criado com sucesso!',
        professionalUpdated: 'Profissional atualizado com sucesso!',
        professionalRemoved: 'Profissional removido com sucesso!',
        serviceCreated: 'Serviço criado com sucesso!',
        serviceRemoved: 'Serviço removido com sucesso!',
        serviceUpdated: 'Serviço atualizado com sucesso!',
        // filas / horários
        queueHoursSet: 'Horários configurados com sucesso!',
        queueHoursUpdated: 'Horários atualizados com sucesso!',
        // frases / campanhas
        phraseCreated: 'Frase criada com sucesso!',
        phraseUpdated: 'Frase alterada com sucesso!',
        phraseDeleted: 'Frase deletada.',
        campaignDeleted: 'Campanha deletada.',
        // fluxos
        flowCreated: 'Fluxo criado com sucesso.',
        flowUpdated: 'Fluxo atualizado com sucesso.',
        flowSaved: 'Fluxo salvo com sucesso.',
        flowDeleted: 'Fluxo excluído com sucesso.',
        flowDuplicated: 'Fluxo duplicado com sucesso.',
        flowExported: 'Fluxo exportado com sucesso.',
        flowImported: 'Fluxo "{{name}}" importado com sucesso!',
        defaultFlowsUpdated: 'Fluxos padrões atualizados.',
        // follow-up
        followUpScheduled: 'Follow-up agendado.',
        followUpCancelled: 'Follow-up cancelado.',
        followUpCreated: 'Follow-up criado com sucesso.',
        followUpByTagScheduled: 'Follow-up por tag agendado.',
        followUpsByTagScheduled: '{{count}} follow-ups por tag agendados.',
        followUpsCreated: '{{count}} follow-ups criados com sucesso.',
        allTicketFollowUpsCancelled: 'Todos os follow-ups do ticket foram cancelados.',
        processingTriggered: 'Processamento acionado.',
        noResponseRuleCreated: 'Regra de tempo sem resposta criada.',
        noResponseRuleUpdated: 'Regra de tempo sem resposta atualizada.',
        recurringRuleCreated: 'Regra de follow-up recorrente criada.',
        recurringRuleUpdated: 'Regra de follow-up recorrente atualizada.',
        tagContactsRuleCreated: 'Regra por tag (contatos) criada.',
        ruleDeleted: 'Regra excluída.',
        // banners / personalização
        bannerCreated: 'Banner criado com sucesso!',
        bannerUpdated: 'Banner atualizado com sucesso!',
        bannerRemoved: 'Banner removido com sucesso!',
        colorsSaved: 'Cores de personalização salvas com sucesso.',
        themeSaved:
          'Todo o tema foi salvo: Menu, Botões e Links, Tipografia e cor primária (quando alterados).',
        emailFooterSaved: 'Configurações do rodapé de e-mail salvas com sucesso.',
        tabTitleUpdated: 'Título da aba atualizado com sucesso.',
        tabIconUpdated: 'Ícone da aba atualizado com sucesso.',
        pwaIconUpdated: 'Ícone PWA atualizado. O backend gerou os tamanhos padrão.',
        // faturas / pagamentos
        invoiceCopyGenerated: '2ª via gerada com sucesso.',
        paymentRegistered: 'Pagamento registrado com sucesso.',
        paymentRemoved: 'Pagamento removido.',
        invoiceDeleted: 'Fatura excluída com sucesso.',
        subscriptionCancelled: 'Assinatura cancelada.',
        subscriptionReactivated: 'Assinatura reativada.',
        // kanban / motivos
        kanbanCreated: 'Kanban criado com sucesso!',
        kanbanTagDeleted: 'Tag Kanban excluída com sucesso.',
        reasonSaved: 'Motivo salvo.',
        reasonCreated: 'Motivo criado!',
        reasonRemoved: 'Motivo removido.',
        // documentação / tokens / mensagens
        tokenGenerated: 'Token gerado com sucesso!',
        tokenCopied: 'Token copiado para a área de transferência!',
        tokenRemoved: 'Token removido com sucesso!',
        messageSent: 'Mensagem enviada com sucesso.',
        // notificações / IA workflow
        notificationSent: 'Notificação enviada!',
        notificationRemoved: 'Notificação removida.',
        notificationsEnabled:
          'Notificações ativadas. Você receberá avisos de novos leads e mensagens.',
        iaWorkflowDeleted: 'Workflow de IA deletado com sucesso!',
        // perfil / quick messages
        profileUpdated: 'Perfil atualizado com sucesso!',
        quickMessageDeleted: 'Resposta rápida excluída com sucesso.',
        importStarted: 'Importação iniciada.',
        queueDeleted: 'Fila excluída com sucesso.',
        emailSent: 'E-mail enviado com sucesso.',
        newCodeSent: 'Novo código enviado para o seu e-mail.',
        passwordChanged: 'Senha alterada com sucesso.',
      },
      toastInfo: {
        cepNotFound: 'CEP não encontrado.',
        noChangesToSave: 'Nenhuma alteração para salvar.',
        noColorChangesToSave: 'Nenhuma alteração de cores para salvar.',
        googleAuthWaiting: 'Ainda aguardando autenticação no Google.',
        completeAuthInWindow: 'Conclua a autenticação na janela aberta.',
        paymentNotConfirmedYet:
          'Pagamento ainda não consta como confirmado. Aguarde e tente de novo.',
        qrNotAvailableYet: 'QR Code ainda não disponível.',
        chargeRequested: 'Cobrança solicitada. Verifique suas faturas em instantes.',
        notificationsDisabled: 'Notificações desativadas.',
        preparingFlowExport: 'Preparando exportação do fluxo...',
        importingFlow: 'Importando fluxo, por favor aguarde...',
        addAtLeastOneMapping: 'Adicione ao menos um mapeamento.',
        couldNotVerifyConnections: 'Não foi possível verificar as conexões. Tente novamente.',
        themeApplied:
          'Tema aplicado ao rascunho (incluindo a cor primária). Use «Salvar todo o tema» acima ou salve cada seção abaixo para gravar no servidor.',
      },
      toastWarning: {
        invalidCreditValue: 'Informe um valor válido de créditos.',
        apiKeyRequired: 'Informe a chave da API {{label}}.',
        modelIdRequired: 'Informe o identificador do modelo.',
        providerRequired: 'Selecione o provedor.',
        modelPricesRequired: 'Informe os preços de input e output (USD por 1M tokens).',
        defaultPlanCannotEdit: 'Este plano é padrão do sistema e não pode ser alterado.',
        defaultPlanCannotDelete: 'Este plano é padrão do sistema e não pode ser excluído.',
        configureAtLeastOneField: 'Configure ao menos um campo para atualizar.',
        nameMinLength: 'Informe um nome com pelo menos 2 caracteres.',
        automationNameRequired: 'Informe um nome para a automação.',
        statusRequired: 'Selecione o status.',
        formRequired: 'Escolha o formulário do gatilho',
        formIdentityRequired: 'Mapeie ao menos e-mail ou telefone para identificar quem respondeu',
        formVariableNameInvalid: 'Dê um nome válido a cada variável (letras, números e _)',
        addAtLeastOneAction: 'Adicione ao menos uma ação.',
        categoryNameRequired: 'Informe o nome da categoria.',
        optionNameRequired: 'Preencha o nome da opção.',
        abbreviationRequired: 'Preencha a sigla.',
        attributeNameRequired: 'Informe o nome do atributo.',
        productNameRequired: 'Preencha o nome do produto.',
        productNameRequiredToContinue: 'Preencha o nome do produto para continuar.',
        invoiceCopyFailed: 'Não foi possível gerar a 2ª via.',
        chargeFailed: 'Não foi possível gerar a cobrança.',
      },
      apiDocs: {
        clientsLoaded: 'Clientes carregados!',
        clientLoaded: 'Cliente carregado!',
        clientCreated: 'Cliente criado com sucesso!',
        clientUpdated: 'Cliente atualizado com sucesso!',
        clientRemoved: 'Cliente removido!',
        queuesLoaded: 'Filas carregadas!',
        queueLoaded: 'Fila carregada!',
        queueCreated: 'Fila criada com sucesso!',
        queueUpdated: 'Fila atualizada com sucesso!',
        queueRemoved: 'Fila removida!',
        connectionsLoaded: 'Conexões carregadas!',
        connectionLoaded: 'Conexão carregada!',
        statusLoaded: 'Status carregado!',
        connectionUpdated: 'Conexão atualizada!',
        connectionRestarting: 'Conexão reiniciando!',
        connectionDisconnected: 'Conexão desconectada!',
        connectionCreated: 'Conexão criada! Aguarde o QR Code.',
        qrAvailable: 'QR Code disponível!',
        connectionRemoved: 'Conexão removida!',
        servicesLoaded: 'Serviços carregados!',
        serviceLoaded: 'Serviço carregado!',
        serviceRemoved: 'Serviço removido!',
        tagsLoaded: 'Tags carregadas!',
        tagLoaded: 'Tag carregada!',
        tagCreated: 'Tag criada com sucesso!',
        tagUpdated: 'Tag atualizada com sucesso!',
        tagRemoved: 'Tag removida!',
        tasksLoaded: 'Tarefas carregadas!',
        taskLoaded: 'Tarefa carregada!',
        taskCreated: 'Tarefa criada com sucesso!',
        taskUpdated: 'Tarefa atualizada com sucesso!',
        taskRemoved: 'Tarefa removida!',
        contactsLoaded: 'Contatos carregados!',
        contactLoaded: 'Contato carregado!',
        contactCreated: 'Contato criado com sucesso!',
        contactUpdated: 'Contato atualizado com sucesso!',
        contactRemoved: 'Contato removido!',
        invoicesLoaded: 'Faturas carregadas!',
        invoiceLoaded: 'Fatura carregada!',
        invoiceCreated: 'Fatura criada!',
        invoiceUpdated: 'Fatura atualizada!',
        invoicePaid: 'Fatura marcada como paga!',
        invoiceCancelled: 'Fatura cancelada!',
        invoiceRemoved: 'Fatura removida!',
        dealsLoaded: 'Negócios carregados!',
        dealLoaded: 'Negócio carregado!',
        dealCreated: 'Negócio criado com sucesso!',
        dealUpdated: 'Negócio atualizado com sucesso!',
        dealRemoved: 'Negócio removido!',
        productsLoaded: 'Produtos carregados!',
        productLoaded: 'Produto carregado!',
        productCreated: 'Produto criado com sucesso!',
        productUpdated: 'Produto atualizado com sucesso!',
        productRemoved: 'Produto removido!',
        usersLoaded: 'Usuários carregados!',
        userLoaded: 'Usuário carregado!',
        userCreated: 'Usuário criado com sucesso!',
        userUpdated: 'Usuário atualizado com sucesso!',
        userRemoved: 'Usuário removido!',
        servicesUpdated: 'Serviços atualizados!',
        scheduleLoaded: 'Agenda carregada!',
        scheduleCreated: 'Agenda criada!',
        appointmentsLoaded: 'Compromissos carregados!',
        appointmentCreated: 'Compromisso criado!',
        statusUpdated: 'Status atualizado!',
        tagsKanbanLoaded: 'Tags kanban carregadas!',
        tagKanbanLoaded: 'Tag kanban carregada!',
        tagKanbanCreated: 'Tag kanban criada com sucesso!',
        tagKanbanUpdated: 'Tag kanban atualizada com sucesso!',
        tagKanbanRemoved: 'Tag kanban removida!',
        ticketsLoaded: 'Tickets carregados!',
        ticketLoaded: 'Ticket carregado!',
        messagesLoaded: 'Mensagens carregadas!',
        ticketUpdated: 'Ticket atualizado!',
        ticketClosed: 'Ticket fechado!',
        ticketReopened: 'Ticket reaberto!',
        ticketTransferred: 'Ticket transferido!',
      },
      backendErrorTokens: {
        ACCESS: 'acesso',
        ACTIVE: 'ativo',
        ANNOUNCEMENT: 'anúncio',
        API: 'API',
        APP: 'aplicativo',
        APPOINTMENT: 'agendamento',
        AUTH: 'autenticação',
        AUTOMATION: 'automação',
        BRL: 'BRL',
        CAMPAIGN: 'campanha',
        CHAT: 'chat',
        CHATBOT: 'chatbot',
        CLIENT: 'cliente',
        CODE: 'código',
        COMPANY: 'empresa',
        CONFIGURED: 'configurado',
        CONNECTION: 'conexão',
        CONTACT: 'contato',
        CREDENTIALS: 'credenciais',
        CREATION: 'criação',
        DELETE: 'exclusão',
        DISABLED: 'desabilitado',
        DUPLICATED: 'duplicado',
        EMAIL: 'e-mail',
        EXPIRED: 'expirado',
        EXTERNAL: 'externa',
        FACEBOOK: 'Facebook',
        FATURA: 'fatura',
        FETCH: 'busca',
        FORBIDDEN: 'proibido',
        FOUND: 'encontrado',
        INACTIVE: 'inativo',
        INTEGRATIONS: 'integrações',
        INTERNAL: 'interno',
        INVALID: 'inválido',
        MEDIA: 'mídia',
        MESSAGE: 'mensagem',
        MISSING: 'ausente',
        NAME: 'nome',
        NO: 'nenhum',
        NOT: 'não',
        OPENAI: 'OpenAI',
        PASSWORD: 'senha',
        PERMISSION: 'permissão',
        PLAN: 'plano',
        PROJECT: 'projeto',
        QUEUE: 'fila',
        REQUIRED: 'obrigatório',
        ROUTE: 'rota',
        SENDING: 'envio',
        SERVICE: 'serviço',
        SESSION: 'sessão',
        SUBSCRIPTION: 'assinatura',
        TAG: 'tag',
        TASK: 'tarefa',
        TICKET: 'ticket',
        TOKEN: 'token',
        USER: 'usuário',
        VALIDATION: 'validação',
        VALUE: 'valor',
        WAPP: 'WhatsApp',
        WHATSAPP: 'WhatsApp',
      },
      publicForm: {
        done: {
          title: 'Tudo certo!',
          subtitle: 'Recebemos sua resposta. Pode fechar esta página.',
        },
      },
      backendErrors: {
        ERR_INVALID_CPF_CNPJ: 'CPF ou CNPJ inválido. Confira os números.',
        ERR_COMPANY_INVALID_NAME: 'Informe o nome da empresa (mínimo 2 letras).',
        ERR_NO_PAYMENT_GATEWAY:
          'Nenhum gateway de pagamento configurado. Cadastre a chave em Configurações > Pagamentos.',
        ERR_TICKET_CHANNEL_NOT_SUPPORTED: 'Este canal de conversa não aceita o envio da fatura.',
        ERR_DISPLAY_NAME_REQUIRED: 'Informe o nome que os clientes devem ver.',
        ERR_DISPLAY_NAME_TOO_LONG: 'O nome de exibição é longo demais.',
        ERR_DISPLAY_NAME_PIN_REQUIRED:
          'Informe o PIN da verificação em duas etapas do número para aplicar o nome aprovado.',
        // WhatsApp API Oficial. Mensagem acionável, não tradução do código: o
        // limite que vem da Meta é dito como tal, porque muda o que a pessoa
        // faz a seguir.
        ERR_TEMPLATE_NAME_INVALID:
          'O nome do template aceita apenas letras minúsculas, números e underscore — sem espaços nem acentos.',
        ERR_TEMPLATE_NAME_TOO_LONG:
          'O nome do template é longo demais. Use no máximo 512 caracteres.',
        ERR_TEMPLATE_ALREADY_EXISTS:
          'Já existe um template com esse nome e idioma nesta conexão. Escolha outro nome ou edite o que já existe.',
        ERR_TEMPLATE_BODY_EMPTY: 'Escreva a mensagem do template antes de enviar para aprovação.',
        ERR_TEMPLATE_BODY_TOO_LONG: 'A mensagem passou de 1024 caracteres, o limite da Meta.',
        ERR_TEMPLATE_BODY_EXAMPLES_REQUIRED:
          'Preencha um exemplo para cada variável do texto. A Meta usa os exemplos na revisão e recusa o template sem eles.',
        ERR_TEMPLATE_BODY_EXAMPLE_EMPTY:
          'Há exemplo de variável em branco. A Meta recusa o template com exemplo vazio.',
        ERR_TEMPLATE_HEADER_TOO_LONG: 'O cabeçalho passou de 60 caracteres, o limite da Meta.',
        ERR_TEMPLATE_HEADER_TOO_MANY_VARIABLES: 'O cabeçalho aceita no máximo uma variável.',
        ERR_TEMPLATE_HEADER_EXAMPLE_REQUIRED: 'Preencha o exemplo da variável do cabeçalho.',
        ERR_TEMPLATE_FOOTER_TOO_LONG: 'O rodapé passou de 60 caracteres, o limite da Meta.',
        ERR_TEMPLATE_FOOTER_NO_VARIABLES:
          'O rodapé não aceita variáveis. Remova a variável para continuar.',
        ERR_TEMPLATE_TOO_MANY_BUTTONS: 'A Meta aceita no máximo 10 botões por template.',
        ERR_TEMPLATE_TOO_MANY_URL_BUTTONS:
          'A Meta aceita no máximo 2 botões de link por template. Remova um para continuar.',
        ERR_TEMPLATE_TOO_MANY_PHONE_BUTTONS:
          'A Meta aceita apenas um botão de ligação por template.',
        ERR_TEMPLATE_BUTTON_TEXT_TOO_LONG:
          'O texto do botão passou de 25 caracteres, o limite da Meta.',
        ERR_TEMPLATE_BUTTON_URL_REQUIRED: 'Informe o link do botão.',
        ERR_TEMPLATE_BUTTON_URL_TOO_LONG: 'O link do botão é longo demais para a Meta aceitar.',
        ERR_TEMPLATE_BUTTON_PHONE_REQUIRED: 'Informe o telefone do botão de ligação.',
        ERR_TEMPLATE_NOT_EDITABLE:
          'Template em análise pela Meta não pode ser editado. Aguarde a resposta ou duplique para criar uma versão nova.',
        ERR_TEMPLATE_NOT_APPROVED: 'Só é possível enviar template aprovado pela Meta.',
        ERR_TEMPLATE_NOT_FOUND:
          'Template não encontrado. Ele pode ter sido excluído — atualize a lista.',
        ERR_TEMPLATE_MEDIA_REQUIRED: 'Envie o arquivo do cabeçalho antes de salvar.',
        ERR_TEMPLATE_MEDIA_TOO_LARGE:
          'O arquivo é grande demais para a Meta aceitar. Reduza o tamanho e envie de novo.',
        ERR_TEMPLATE_MEDIA_TYPE:
          'A Meta não aceita esse tipo de arquivo para o cabeçalho do template.',
        ERR_OFFICIAL_WINDOW_CLOSED:
          'Passaram 24 horas desde a última mensagem do cliente. Envie um template aprovado para retomar — a resposta dele libera o texto livre de novo.',
        ERR_INVALID_TWO_STEP_PIN: 'O PIN da verificação em duas etapas precisa ter 6 dígitos.',
        ERR_REGISTERING_PHONE_NUMBER:
          'A Meta recusou o registro do número. Se ele já usa verificação em duas etapas, confira se o PIN informado é o atual.',
        ERR_OFFICIAL_CREDENTIALS_INVALID:
          'A Meta não aceitou estas credenciais. Confira o Phone Number ID e o token permanente.',
        ERR_PLAN_WHATSAPP_OFFICIAL_DISABLED:
          'Seu plano não inclui o WhatsApp API Oficial. Fale com o responsável pela conta para contratar.',
        // Agendamento para grupos. Sem estas chaves o `toastError` "humaniza" o
        // código — foi assim que "Group schedule daily limit reached" apareceu
        // em inglês na tela.
        ERR_GROUP_SCHEDULE_DAILY_LIMIT_REACHED:
          'O limite de disparos de hoje já foi atingido. Os envios programados continuam normalmente amanhã.',
        ERR_GROUP_SCHEDULE_CONNECTION_OFFLINE:
          'A conexão deste agendamento está fora do ar. Reconecte em Conexões e dispare de novo — nenhum envio foi feito e a cota do dia segue intacta.',
        ERR_GROUP_SCHEDULE_NO_CONNECTION:
          'Este agendamento está sem conexão. Abra a edição e escolha por qual conexão ele deve enviar.',
        ERR_GROUP_SCHEDULE_NOT_ACTIVE:
          'Só dá para disparar agendamento ativo. Retome-o antes de enviar.',
        ERR_GROUP_SCHEDULE_ALREADY_RUNNING:
          'Este agendamento já está enviando agora. Aguarde terminar.',
        ERR_GROUP_SCHEDULE_NOT_FOUND: 'Este agendamento não existe mais.',
        ERR_CONNECTION_NOT_FOUND: 'A conexão escolhida não existe mais. Escolha outra e salve.',
        ERR_CONNECTION_DOES_NOT_ALLOW_GROUPS:
          'Esta conexão está com grupos desativados. Ative nas configurações dela ou escolha outra conexão.',
        ERR_INVALID_GROUP_SELECTION:
          'Um dos grupos escolhidos não está mais disponível. Abra a edição e selecione os grupos de novo.',
        ERR_INVALID_STATUS: 'Situação inválida para este agendamento.',
        ERR_NO_FILE_UPLOADED: 'Nenhum arquivo foi enviado.',
        ERR_FILE_TYPE_NOT_ALLOWED:
          'Esse tipo de arquivo não é permitido por segurança (ex.: .xml, .html, .svg, .js). Compacte em .zip para enviar.',
        ERR_FILE_TOO_LARGE: 'Arquivo muito grande para envio.',
        ERR_MCP_CONNECTION_MUST_REVOKE_FIRST:
          'Revogue a conexão antes de excluí-la definitivamente.',
        ERR_DESCRIPTION_TOO_LONG: 'A descrição do calendário pode ter no máximo 300 caracteres.',
        ERR_OVERLAPPING_AVAILABILITY:
          'Há janelas de horário sobrepostas no mesmo dia. Ajuste os horários e salve novamente.',
        ERR_INVALID_TIME_WINDOW: 'O horário final precisa ser maior que o inicial.',
        ERR_HOST_BUSY: 'Este profissional já tem um compromisso neste horário.',
        ERR_SLOT_FULL: 'Este horário já atingiu o limite de agendamentos.',
        ERR_APPOINTMENT_CANCELLED:
          'Este compromisso foi cancelado e não pode mais ser alterado. Crie um novo agendamento.',
        ERR_CANCEL_REASON_REQUIRED:
          'Informe o motivo do cancelamento — ele vai no e-mail do convidado.',
        ERR_APPOINTMENT_NOT_FOUND: 'Compromisso não encontrado — ele pode ter sido removido.',
        ERR_APPOINTMENT_TITLE_REQUIRED: 'Informe o título do compromisso.',
        ERR_CALENDAR_INACTIVE: 'Este calendário está inativo e não aceita novos agendamentos.',
        ERR_CALENDAR_HAS_APPOINTMENTS:
          'Este calendário já tem compromissos e não pode ser excluído — desative-o para parar de receber agendamentos.',
        ERR_CALENDAR_NAME_REQUIRED: 'Informe o nome do calendário.',
        ERR_OUTSIDE_AVAILABILITY: 'Este horário está fora do expediente do calendário.',
        ERR_DATE_RANGE_TOO_LONG: 'Período muito longo — consulte no máximo 62 dias por vez.',
        ERR_INVALID_DATE_RANGE: 'A data final não pode ser anterior à inicial.',
        ERR_INVALID_DATE_FORMAT: 'Data inválida.',
        ERR_INVALID_TIME_FORMAT: 'Horário inválido — use o formato HH:MM.',
        ERR_INVALID_WEEKDAY: 'Dia da semana inválido.',
        ERR_INVALID_DURATION: 'Duração inválida — use de 5 minutos a 24 horas.',
        ERR_INVALID_TIMEZONE: 'Fuso horário inválido.',
        ERR_INVALID_LOCATION_TYPE: 'Tipo de local inválido.',
        ERR_INVALID_DISTRIBUTION: 'Forma de distribuição inválida.',
        ERR_INVALID_CALENDAR_USER: 'Um dos profissionais escolhidos não pertence a esta empresa.',
        ERR_EVENT_TYPE_NOT_FOUND: 'Tipo de evento não encontrado.',
        ERR_DUPLICATE_DATE_OVERRIDE: 'Já existe uma exceção cadastrada para esta data.',
        ERR_OVERRIDE_TIME_REQUIRED:
          'Informe o horário da exceção ou marque o dia como indisponível.',
        ERR_GUEST_NAME_REQUIRED: 'Informe seu nome para agendar.',
        ERR_GUEST_PHONE_REQUIRED: 'Informe seu telefone para agendar.',
        ERR_INVALID_GUEST_EMAIL: 'Informe um e-mail válido — é para lá que vai a confirmação.',
        ERR_DUPLICATE_REMINDER_RULE: 'Este lembrete já foi adicionado.',
        ERR_DUPLICATE_GUEST: 'Este convidado já está na lista.',
        ERR_TOO_MANY_GUESTS: 'Máximo de 20 convidados por compromisso.',
        ERR_INVALID_REMINDER_OFFSET: 'Antecedência inválida — use de 5 minutos a 30 dias.',
        ERR_INVALID_REMINDER_CHANNEL: 'Por enquanto o lembrete só é enviado por e-mail.',
        ERR_EMAIL_ACCOUNT_NOT_FOUND: 'Conta de e-mail não encontrada.',
        ERR_EMAIL_ACCOUNT_NAME_REQUIRED: 'Dê um nome à conta de e-mail.',
        ERR_SMTP_HOST_REQUIRED: 'Informe o servidor SMTP.',
        ERR_SMTP_USER_REQUIRED: 'Informe o usuário do servidor SMTP.',
        ERR_SMTP_PASSWORD_REQUIRED: 'Informe a senha da conta de e-mail.',
        ERR_INVALID_SMTP_FROM: 'Informe um e-mail remetente válido.',
        ERR_INVALID_SMTP_PORT: 'Porta inválida — use 587 (TLS) ou 465 (SSL).',
        ERR_INVALID_TEST_EMAIL: 'Informe um e-mail válido para receber o teste.',
        ERR_DAY_FULL: 'Este dia já atingiu o limite de agendamentos.',
        ERR_TOO_LATE_TO_BOOK: 'Este horário está dentro da antecedência mínima do calendário.',
        ERR_TOO_FAR_AHEAD: 'Este horário está além do período que o calendário aceita.',
        ERR_HOST_NOT_IN_CALENDAR: 'Este profissional não atende neste calendário.',
        ERR_HOST_HAS_UPCOMING_APPOINTMENTS:
          'Este profissional tem compromissos futuros neste calendário. Reatribua ou cancele antes de removê-lo.',
        ERR_EVENT_TYPE_REQUIRED_FOR_CUSTOM: 'Escolha um tipo de evento para o local personalizado.',
        ERR_INVALID_SLUG: 'O endereço do link aceita apenas letras minúsculas, números e hífen.',
        ERR_CALENDAR_NOT_FOUND: 'Calendário não encontrado.',
        ERR_NO_CALENDAR_ACCESS: 'Você não tem acesso a este calendário.',
        ERR_PLAN_APPOINTMENTS_DISABLED: 'A Agenda não está incluída no seu plano.',
        ERR_PLAN_TELEGRAM_DISABLED: 'O Telegram não está incluído no seu plano.',
        ERR_TELEGRAM_INVALID_BOT_TOKEN:
          'Token do bot inválido. Copie o token inteiro do BotFather.',
        ERR_TELEGRAM_INVALID_CONNECTION_DATA:
          'Dados da conexão inválidos. Confira o nome e o token.',
        ERR_TELEGRAM_UNREACHABLE: 'Não foi possível falar com o Telegram agora. Tente novamente.',
        ERR_TELEGRAM_BOT_ALREADY_CONNECTED: 'Este bot já está conectado em outra conexão.',
        ERR_TELEGRAM_DIFFERENT_BOT: 'Este token é de outro bot. Use o token do bot desta conexão.',
        ERR_TELEGRAM_SET_WEBHOOK_FAILED:
          'O Telegram recusou registrar o webhook. Tente reconectar.',
        ERR_TELEGRAM_WEBHOOK_URL_NOT_HTTPS:
          'O endereço do servidor precisa ser HTTPS para o Telegram.',
        ERR_TELEGRAM_NOT_CONNECTED: 'Esta conversa não tem um bot do Telegram conectado.',
        ERR_TELEGRAM_CHAT_UNREACHABLE:
          'Não foi possível enviar: a pessoa bloqueou o bot ou saiu do grupo.',
        ERR_TELEGRAM_RATE_LIMITED: 'O Telegram limitou os envios. Aguarde alguns segundos.',
        ERR_SENDING_TELEGRAM_MSG: 'Erro ao enviar mensagem pelo Telegram. Verifique a conexão.',
        ERR_TELEGRAM_REACTION_NOT_ALLOWED: 'O Telegram não aceita este emoji como reação.',
        ERR_TELEGRAM_EDIT_NOT_ALLOWED:
          'Só dá para editar texto enviado por você e dentro do limite do Telegram.',
        ERR_TELEGRAM_DELETE_NOT_ALLOWED:
          'O Telegram não permite apagar esta mensagem (passou de 48 horas).',
        ERR_TELEGRAM_MESSAGE_NOT_FOUND: 'Mensagem do Telegram não encontrada.',
        ERR_NO_OTHER_WHATSAPP: 'Deve haver pelo menos um WhatsApp padrão.',
        ERR_NO_DEF_WAPP_FOUND: 'Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.',
        ERR_WAPP_NOT_INITIALIZED:
          'Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.',
        ERR_WAPP_CHECK_CONTACT:
          'Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões',
        ERR_WAPP_INVALID_CONTACT: 'Este não é um número de Whatsapp válido.',
        ERR_WAPP_DOWNLOAD_MEDIA:
          'Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.',
        ERR_INVALID_CREDENTIALS: 'Erro de autenticação. Por favor, tente novamente.',
        ERR_INVALID_TOKEN: 'Token inválido. Faça login novamente.',
        ERR_SENDING_WAPP_MSG:
          'Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.',
        ERR_SENDING_FACEBOOK_MSG:
          'Erro ao enviar mensagem pelo Facebook/Instagram. Verifique a conexão.',
        instagram_does_not_support_this_media_type:
          'O Instagram não suporta este tipo de arquivo. Envie apenas imagens JPEG, PNG, GIF ou WEBP.',
        ERR_DELETE_WAPP_MSG: 'Não foi possível excluir a mensagem do WhatsApp.',
        ERR_OFFICIAL_DELETE_NOT_SUPPORTED:
          'A API Oficial do WhatsApp não permite apagar mensagens já enviadas.',
        ERR_OFFICIAL_EDIT_NOT_SUPPORTED:
          'A API Oficial do WhatsApp não permite editar mensagens já enviadas.',
        ERR_OTHER_OPEN_TICKET: 'Já existe um tíquete aberto para este contato.',
        ERR_SESSION_EXPIRED: 'Sessão expirada. Por favor entre.',
        ERR_HEADER_OR_COOKIE_TOO_LARGE:
          'Cookies/cabeçalho do navegador muito grandes. Use o modal de limpeza ou limpe os cookies do site da API.',
        ERR_NO_AUTH_TOKEN: 'Requisição sem token de autorização. Faça login novamente.',
        ERR_ACCESS_TOKEN_EXPIRED: 'Token de acesso expirado. Atualize a página ou faça login.',
        ERR_REFRESH_TOKEN_MISSING: 'Refresh token ausente. Faça login novamente.',
        ERR_REFRESH_TOKEN_EXPIRED: 'Refresh token expirado. Faça login novamente.',
        ERR_REFRESH_TOKEN_INVALID: 'Refresh token inválido. Faça login novamente.',
        ERR_SESSION_REVOKED:
          'Sessão invalidada (ex.: logout em outro dispositivo). Faça login novamente.',
        ERR_AUTH_REQUIRED: 'Autenticação necessária. Faça login para continuar.',
        ERR_APP_NOT_ACTIVE:
          'O aplicativo ou integração não está ativo. Verifique nas configurações ou com o suporte.',
        ERR_PLAN_INTERNAL_CHAT_DISABLED:
          'O chat interno não está disponível no plano atual da empresa.',
        ERR_PLAN_INTEGRATIONS_DISABLED:
          'Integrações não estão disponíveis no plano atual da empresa.',
        ERR_COMPANY_APP_ALREADY_CANCELLED: 'Este app já foi desativado anteriormente.',
        ERR_COMPANY_TOKEN_MISSING: 'Token da empresa não informado.',
        ERR_COMPANY_TOKEN_NOT_CONFIGURED: 'Token da empresa não configurado no servidor.',
        ERR_COMPANY_TOKEN_INVALID: 'Token da empresa inválido.',
        ERR_API_TOKEN_MISSING: 'Token da API não informado.',
        ERR_API_TOKEN_NOT_CONFIGURED: 'Integração sem token configurado.',
        ERR_API_TOKEN_INVALID: 'Token da API inválido.',
        ERR_USER_CREATION_DISABLED: 'A criação do usuário foi desabilitada pelo administrador.',
        ERR_NO_PERMISSION: 'Você não tem permissão para acessar este recurso.',
        ERR_META_PIXEL_NOT_FOUND: 'Pixel não encontrado.',
        ERR_META_CUSTOM_EVENT_NAME_INVALID:
          'Use apenas letras, números e underscore, começando por letra (ex.: OrcamentoAprovado).',
        ERR_META_CUSTOM_EVENT_NAME_RESERVED:
          'Esse nome já é um evento padrão do Meta. Escolha outro.',
        ERR_META_CUSTOM_EVENT_DUPLICATE: 'Já existe um evento com esse nome.',
        ERR_META_CUSTOM_EVENT_NOT_FOUND: 'Evento personalizado não encontrado.',
        ERR_META_PIXEL_NAME_REQUIRED: 'Informe um nome para identificar o pixel.',
        ERR_META_PIXEL_ID_REQUIRED: 'Informe o ID do pixel.',
        ERR_META_PIXEL_ID_INVALID: 'O ID do pixel deve conter apenas números.',
        ERR_META_PIXEL_TOKEN_REQUIRED: 'Informe o token da Conversions API.',
        ERR_META_PIXEL_CURRENCY_INVALID: 'Informe a moeda com 3 letras (ex.: BRL, USD, EUR).',
        ERR_META_PIXEL_TEST_CODE_REQUIRED:
          'Cadastre o código de evento de teste no pixel antes de testar.',
        ERR_DUPLICATED_CONTACT: 'Já existe um contato com este número.',
        ERR_REQUIRED_TAG_TO_CLOSE_TICKET:
          'É obrigatório adicionar uma etiqueta ao contato antes de encerrar o ticket.',
        ERR_CRM_INSUFFICIENT_STOCK:
          'Estoque insuficiente para um ou mais produtos da oportunidade. A venda não foi marcada como ganha.',
        ERR_CRM_OPPORTUNITY_NOT_FOUND:
          'Não encontramos esta oportunidade. Ela pode ter sido excluída.',
        ERR_CRM_OPPORTUNITY_LOCKED: 'Esta oportunidade está fechada e não pode ser editada.',
        ERR_CRM_LOSS_REASON_REQUIRED: 'Informe o motivo da perda antes de concluir.',
        ERR_CRM_PRODUCT_NOT_FOUND: 'Produto da oportunidade não encontrado.',
        ERR_TASK_NOT_FOUND: 'Não encontramos esta tarefa. Ela pode ter sido excluída.',
        ERR_TASK_IN_TRASH: 'Esta tarefa está na lixeira. Restaure-a para poder editar.',
        ERR_TASK_REASON_REQUIRED: 'Informe o motivo para cancelar ou abandonar a tarefa.',
        ERR_TASK_INVALID_DATA:
          'Não foi possível salvar a tarefa. Confira o título, o status e a data de vencimento.',
        ERR_NO_SETTING_FOUND: 'Nenhuma configuração encontrada com este ID.',
        ERR_NO_CONTACT_FOUND: 'Não encontramos este contato. Ele pode ter sido excluído.',
        ERR_NO_TICKET_FOUND: 'Não encontramos este ticket. Ele pode ter sido excluído.',
        ERR_NO_PROMPT_FOUND: 'Agente de IA não encontrado.',
        ERR_AI_AGENT_UNSUPPORTED_TICKET:
          'O agente de IA só atende conversas individuais de conexões WhatsApp.',
        ERR_AI_AGENT_TICKET_CLOSED: 'Reabra o ticket antes de ativar um agente de IA.',
        ERR_PLAN_AI_DISABLED: 'O plano da empresa não inclui agente de IA.',
        ERR_NO_USER_FOUND: 'Não encontramos este usuário. Ele pode ter sido removido da empresa.',
        ERR_NO_WAPP_FOUND: 'Nenhum WhatsApp encontrado com este ID.',
        ERR_CREATING_MESSAGE: 'Erro ao criar mensagem no banco de dados.',
        ERR_CREATING_TICKET: 'Erro ao criar tíquete no banco de dados.',
        ERR_FETCH_WAPP_MSG: 'Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.',
        ERR_QUEUE_COLOR_ALREADY_EXISTS: 'Esta cor já está em uso, escolha outra.',
        ERR_QUEUE_NOT_FOUND: 'Fila não encontrada. Atualize a página e tente novamente.',
        ERR_WAPP_GREETING_REQUIRED:
          'A mensagem de saudação é obrigatório quando há mais de uma fila.',
        ERR_OUT_OF_HOURS: 'Fora do Horário de Expediente!',
        ERR_USER_PLAN_BLOCKED:
          'Conta bloqueada: o plano da empresa permite menos usuários do que ela tem. Fale com o administrador da sua empresa.',
        ERR_USER_NOT_PLAN_BLOCKED: 'Este usuário não está bloqueado pelo plano.',
        ERR_USER_CANNOT_BE_PLAN_BLOCKED: 'Este usuário não pode ser bloqueado pelo plano.',
        ERR_WAPP_PLAN_BLOCKED:
          'Esta conexão está bloqueada pelo plano. Mude de plano ou libere-a na tela de conexões.',
        ERR_WAPP_NOT_PLAN_BLOCKED: 'Esta conexão não está bloqueada pelo plano.',
        ERR_WAPP_ALREADY_PLAN_BLOCKED: 'Esta conexão já está bloqueada pelo plano.',
        ERR_QUEUE_NOT_PLAN_BLOCKED: 'Este departamento não está bloqueado pelo plano.',
        ERR_QUEUE_ALREADY_PLAN_BLOCKED: 'Este departamento já está bloqueado pelo plano.',
        ERR_EMAIL_ALREADY_EXISTS: 'Este e-mail já está em uso.',
        ERR_COMPANY_NAME_ALREADY_EXISTS: 'Este nome de empresa já está cadastrado.',
        ERR_COMPANY_DOCUMENT_ALREADY_EXISTS: 'Este CPF/CNPJ já está cadastrado.',
        ERR_UNIQUE_CONSTRAINT_VIOLATION:
          'Já existe um registro com esse valor. Verifique os campos e tente novamente.',
        ERR_META_IMPORT_TOKEN_MISSING:
          'Conecte a página em Configurações > Conexões antes de importar.',
        ERR_META_IMPORT_PAGE_NOT_FOUND:
          'Nenhuma conexão encontrada para pageId. Vincule a página em Configurações > Conexões.',
        ERR_ROUTE_NOT_FOUND:
          'Rota ou recurso não encontrado. Verifique o endereço ou tente novamente.',
        ERR_CREATING_FOLLOW_UP:
          'Não foi possível criar o follow-up. Verifique os dados e tente novamente.',
        ERR_FOLLOW_UP_SCHEDULED_AT_INVALID:
          'Data e hora do agendamento inválidas. Preencha o campo novamente.',
        ERR_FOLLOW_UP_SCHEDULED_AT_IN_PAST:
          'A data e hora do agendamento já passaram. Escolha um horário futuro.',
        ERR_FOLLOW_UP_SCHEDULE_REQUIRED:
          'Informe o delay em minutos ou uma data e hora para o agendamento.',
        ERR_FOLLOW_UP_TICKETS_REQUIRED: 'Selecione pelo menos um atendimento.',
        ERR_FOLLOW_UP_NOT_FOUND: 'Follow-up pendente não encontrado.',
        ERR_PASSWORD_RESET_CODE_INVALID:
          'Código inválido ou expirado. Verifique o código ou solicite um novo.',
        ERR_PROMPT_INTELLIGENCE_INVALID:
          'A configuração de inteligência deste prompt é inválida. Revise modelo, ferramentas e campos obrigatórios.',
        missing_code_or_state: 'Autorização cancelada ou expirada. Tente novamente.',
        invalid_or_expired_state: 'Sessão de autorização expirada. Inicie o processo novamente.',
        no_pages_found:
          'Nenhuma página do Facebook foi liberada para o app. Confira: (1) você marcou a página na tela de autorização do Facebook; (2) você tem o papel de Administrador nela — Editor e Moderador não podem autorizar apps; (3) se a página pertence a um Portfólio Empresarial, o acesso precisa ser concedido por lá.',
        pages_fetch_failed:
          'Não foi possível consultar suas páginas no Facebook. Tente novamente em alguns minutos; se persistir, acione o suporte.',
        subscribe_failed:
          'Página conectada, mas o webhook não foi ativado. Verifique se o app está em modo Live.',
        token_exchange_failed: 'Erro ao autenticar a página. Tente reconectar.',
        conflict: 'Esta página já está em uso por outra conta. Desconecte-a antes de continuar.',
        ERR_CHAT_MESSAGE_DELETE_FORBIDDEN: 'Só quem enviou a mensagem pode excluí-la.',
        ERR_REACTIONS_WHATSAPP_ONLY: 'Reações só estão disponíveis em conversas WhatsApp.',
        ERR_REACTIONS_INVALID_TARGET: 'Não é possível reagir a este tipo de mensagem.',
        ERR_REACTIONS_NOT_AVAILABLE_PRIVATE: 'Não é possível reagir a mensagens privadas.',
        ERR_MESSAGE_KEY_UNAVAILABLE:
          'Não foi possível reagir: dados da mensagem no WhatsApp não estão disponíveis.',
        ERR_SENDING_WAPP_REACTION:
          'Erro ao enviar a reação pelo WhatsApp. Verifique a sessão e tente novamente.',
        ERR_WAPP_NOT_CONNECTED: 'WhatsApp não está conectado. Verifique a página de conexões.',
        ERR_CLIENT_REACTION_INVALID_MESSAGE_ID:
          'Aguarde a mensagem ser salva no servidor antes de reagir.',
        ERR_LUNCH_MIN_ONE_HOUR: 'O intervalo de almoço deve ter no mínimo 1 hora.',
        ERR_ROLE_NOT_FOUND: 'Perfil de acesso não encontrado.',
        ERR_ROLE_HAS_USERS: 'Não é possível excluir: há usuários vinculados a este perfil.',
        ERR_ROLE_DEFAULT_CANNOT_BE_DELETED: 'Perfis padrão do sistema não podem ser excluídos.',
        ERR_ROLE_DEFAULT_CANNOT_BE_EDITED: 'Perfis padrão do sistema não podem ser editados.',
        ERR_ROLE_NAME_ALREADY_EXISTS: 'Já existe um perfil com este nome.',
        ERR_ROLE_INVALID_NAME: 'O nome do perfil deve ter pelo menos 2 caracteres.',
      },
      roles: {
        title: 'Perfis de Acesso',
        subtitle: 'Gerencie os perfis e permissões dos usuários da empresa',
        table: {
          name: 'Nome',
          description: 'Descrição',
          permissions: 'Permissões',
          users: 'Usuários',
          actions: 'Ações',
          default: 'Padrão',
        },
        buttons: {
          add: 'Novo Perfil',
          edit: 'Editar',
          view: 'Visualizar',
          delete: 'Excluir',
        },
        confirmDelete: {
          title: 'Excluir perfil',
          message: 'Deseja excluir o perfil "{{name}}"? Esta ação não pode ser desfeita.',
        },
        toasts: {
          deleted: 'Perfil excluído com sucesso.',
          created: 'Perfil criado com sucesso.',
          updated: 'Perfil atualizado com sucesso.',
        },
      },
      roleForm: {
        subtitle: 'Defina nome, descrição e selecione as permissões do perfil de acesso.',
        nameRequired: 'Nome do perfil é obrigatório.',
      },
      userPermissionsTab: {
        adminInfo:
          'Usuários com perfil Admin têm acesso total a todas as funcionalidades. Nenhuma configuração de permissões é necessária.',
        adminProfileHint:
          'Este usuário tem perfil Administrador. As permissões abaixo já valem para ele — apenas o proprietário da conta tem acesso total irrestrito. Use-as para restringir, por exemplo, quais tickets e conexões ele enxerga.',
        roleSection: {
          title: 'Perfil de Acesso',
          label: 'Perfil de acesso',
          noRole: 'Sem perfil (acesso mínimo)',
          default: 'padrão',
        },
        permissionsSection: {
          title: 'Permissões do usuário',
          hint: 'Ao escolher um perfil, as permissões dele já vêm marcadas. Ajuste os checks para personalizar este usuário.',
        },
      },
      roleModal: {
        title: {
          add: 'Novo Perfil de Acesso',
          edit: 'Editar Perfil de Acesso',
        },
        form: {
          name: 'Nome do perfil',
          description: 'Descrição (opcional)',
          permissions: 'Permissões',
          searchPermissions: 'Buscar permissão...',
          selectAll: 'Selecionar todos',
          deselectAll: 'Desmarcar todos',
        },
        buttons: {
          cancel: 'Cancelar',
          save: 'Salvar',
        },
        modules: {
          agenda: 'Agenda',
          marketing: 'Marketing',
          group_schedules: 'App Agendamento para Grupos',
          whatsapp_templates: 'Templates do WhatsApp Oficial',
          tickets: 'Tickets',
          contacts: 'Contatos',
          queues: 'Filas',
          connections: 'Conexões',
          dashboard: 'Dashboard',
          reports: 'Relatórios',
          users: 'Usuários',
          roles: 'Perfis de Acesso',
          chat: 'Chat Interno',
          quick_messages: 'Respostas Rápidas',
          campaigns: 'Campanhas',
          schedules: 'Agendamentos',
          tags: 'Tags',
          settings: 'Configurações',
          realtime: 'Tempo Real',
          crm: 'CRM',
          clients: 'Clientes',
          tasks: 'Tarefas',
          projects: 'Projetos/Tarefas',
          integrations: 'Integrações',
          flows: 'Fluxos',
          flowbuilder: 'Flow Builder',
          automations: 'Automações',
          followup: 'Follow-up',
          no_response: 'Tempo sem resposta',
          ia: 'IA / Workflows',
          services: 'Serviços',
          products: 'Produtos',
          financial: 'Financeiro',
          mass_dispatch: 'Disparo em massa',
          forms: 'App SmartForms',
          api: 'API',
        },
      },
      performanceConfig: {
        title: 'Configurações de performance',
        subtitle:
          'Ajuste limites de desempenho do sistema. Use o ícone de informação ao lado de cada opção para entender o que ela faz antes de alterar.',
        back: 'Voltar',
        docsButton: 'Documentação',
        save: 'Salvar configurações',
        saving: 'Salvando…',
        cancel: 'Cancelar',
        dialogDescription:
          'Valores personalizados substituem o padrão do sistema e costumam entrar em vigor em até 30 segundos. Na seção "Ajustes por empresa", é possível definir limites diferentes para cada empresa.',
        banner: {
          title: 'Como usar esta tela',
          text: 'Cada opção controla o desempenho do sistema. Clique ou passe o mouse no ícone de informação ao lado do nome para entender o que ela faz. Se tiver dúvida, mantenha "Usar padrão" ligado e só altere com orientação do suporte técnico.',
        },
        row: {
          // `{{- x}}` = interpolação SEM escape de HTML. O i18next escapa por
          // padrão, e as unidades têm barra ("msgs/janela", "req/janela"): com
          // `{{x}}` a tela mostrava literalmente "1 msgs&#x2f;janela", porque o
          // React renderiza a entidade como texto em vez de decodificar. Só
          // vale para valor/unidade, que saem do nosso próprio registry — min e
          // max são números e seguem escapados.
          systemDefault: 'Valor padrão do sistema: {{- value}}',
          allowedBetween: ' · permitido entre {{min}} e {{max}}{{- unit}}',
          perProcess: ' · por processo: {{total}} no total, somando {{count}} engines',
          useDefault: 'Usar padrão',
          enabled: 'Ativado',
          disabled: 'Desativado',
        },
        chips: {
          needsRestart: 'precisa reiniciar',
          waitingRestart: 'aguardando restart',
          perCompany: 'por empresa',
          restartPendingTooltip:
            'A alteração já foi salva, mas o servidor ainda está usando o valor antigo. Reinicie o servidor para aplicar o novo valor.',
          perCompanyTooltip:
            'Esta opção aceita um valor específico por empresa, útil quando uma empresa precisa de mais capacidade sem afetar as demais.',
        },
        help: {
          whatItDoes: 'O que esta opção faz',
          inPractice: 'Na prática',
          allowedRange: 'Faixa permitida: {{min}} a {{max}}{{- unit}}.',
          companyOverrideHint:
            'Você pode definir um valor diferente para empresas específicas na seção "Ajustes por empresa".',
          restartHint:
            'Depois de salvar, o servidor precisa ser reiniciado para esta opção entrar em vigor.',
          defaultToggle:
            'Ligado: mantém o valor recomendado pelo sistema. Desligado: permite definir um valor personalizado para esta opção.',
          viewExplanation: 'Ver explicação',
          aboutOption: 'Explicação sobre {{label}}',
          defaultAria: 'Usar valor padrão para {{label}}',
          defaultHow: 'Como funciona o valor padrão de {{label}}',
          fallback: 'Ajuste de desempenho do sistema para equilibrar velocidade e estabilidade.',
          uncertainPractice:
            'Se não tiver certeza, mantenha o valor padrão ou converse com o suporte técnico antes de alterar.',
          keys: {
            wa_throttle_max_per_window:
              'Limita quantas mensagens cada número de WhatsApp pode enviar em um período. Se passar do limite, os envios esperam um pouco antes de continuar — isso reduz o risco de bloqueio pelo WhatsApp.',
            wa_throttle_window_ms:
              'Define o tamanho do período usado para contar os envios de cada número. Exemplo: com janela de 1 minuto, o limite de mensagens vale para cada minuto.',
            wa_send_max_concurrent_per_company:
              'Controla quantas mensagens uma empresa pode enviar ao mesmo tempo. Evita que uma empresa monopolize o sistema e prejudique as outras.',
            wa_send_max_concurrent_global:
              'Define quantas mensagens o sistema inteiro pode enviar ao mesmo tempo. Ajuda a manter o servidor estável em picos de uso.',
            wa_queue_max_depth:
              'Limite de mensagens que podem ficar na fila de envio. Acima disso, novos envios podem ser recusados ou atrasados até a fila esvaziar.',
            wa_send_delay_ms:
              'Pausa mínima entre um envio e outro na mesma conexão. Um intervalo maior deixa o envio mais natural e pode reduzir bloqueios.',
          },
          practice: {
            wa_throttle_max_per_window:
              'Aumente com cuidado se houver muita fila; diminua se notar bloqueios ou avisos do WhatsApp.',
            wa_throttle_window_ms:
              'Janelas menores reagem mais rápido; janelas maiores permitem picos curtos sem travar.',
            wa_send_max_concurrent_per_company:
              'Útil para dar mais capacidade a empresas grandes na seção "Ajustes por empresa".',
          },
          patterns: {
            windowConnection:
              'Limita quantas mensagens cada número de WhatsApp pode enviar em um período. Se passar do limite, os envios esperam um pouco antes de continuar — isso reduz o risco de bloqueio pelo WhatsApp.',
            windowConnectionPractice:
              'Aumente com cuidado se houver muita fila; diminua se notar bloqueios.',
            windowMs:
              'Define o tamanho do período usado para contar os envios. Valores menores reagem mais rápido; valores maiores permitem picos curtos.',
            concurrent:
              'Controla quantas operações podem acontecer ao mesmo tempo. Valores altos aceleram, mas podem sobrecarregar o servidor.',
            fairness:
              'Distribui recursos de forma justa entre as empresas, para que uma não use tudo e prejudique as outras.',
            queue:
              'Limite de itens que podem ficar aguardando processamento. Evita acúmulo excessivo quando o sistema está sobrecarregado.',
            delay:
              'Tempo de espera entre uma ação e outra. Intervalos maiores deixam o comportamento mais suave e previsível.',
            timeout:
              'Quanto tempo o sistema espera antes de desistir de uma operação que não respondeu.',
            worker:
              'Configuração dos processos que rodam em segundo plano no servidor. Algumas mudanças só valem depois de reiniciar o servidor.',
            memory:
              'Limite de memória usada pelo servidor. Ajuda a evitar travamentos quando há muito uso ao mesmo tempo.',
            externalApi:
              'Controla chamadas a serviços externos para não ultrapassar os limites deles e evitar erros ou bloqueios.',
            meta: 'Ajusta integrações com Facebook e Instagram conforme os limites da plataforma Meta.',
          },
        },
        overrides: {
          title: 'Ajustes por empresa',
          hint: 'Use esta seção quando uma empresa específica precisa de mais recursos do que as outras. O valor da empresa tem prioridade sobre o valor geral da tela.',
          aboutAria: 'Explicação sobre ajustes por empresa',
          example:
            'Exemplo: liberar mais capacidade para uma empresa grande sem mudar o limite das demais.',
          company: 'Empresa',
          configuration: 'Configuração',
          value: 'Valor',
          companyFallback: 'Empresa #{{id}}',
          removeTooltip: 'Remover ajuste desta empresa (volta ao valor geral)',
          removeAria: 'Remover ajuste de {{config}} para {{company}}',
          noCompanies: 'Nenhuma empresa encontrada',
          add: 'Adicionar',
        },
        validation: {
          enterNumber: 'Informe um número',
          min: 'Mínimo: {{min}}',
          max: 'Máximo: {{max}}',
        },
        toasts: {
          savedRestart:
            'Configurações salvas. Algumas opções só passam a valer depois de reiniciar o servidor.',
          saved: 'Configurações salvas — propagam em até 30 segundos.',
          duplicateOverride:
            'Esta empresa já tem um ajuste para essa opção — edite o valor na lista.',
        },
        saveConfirm: {
          title: 'Termo de responsabilidade',
          paragraph1:
            'As configurações de performance afetam diretamente a infraestrutura e o desempenho do sistema. Alterações inadequadas podem causar instabilidade, lentidão, perda de mensagens ou interrupção de serviços.',
          paragraph2:
            'Recomendamos manter os valores padrão ou alterar apenas com orientação do suporte técnico.',
          paragraph3:
            'Ao confirmar, você declara estar ciente das consequências e assume total responsabilidade pelas alterações realizadas, isentando o fornecedor e o revendedor do sistema de qualquer prejuízo decorrente do uso incorreto destas configurações.',
          checkbox: 'Li e aceito o termo de responsabilidade',
          confirm: 'Confirmar e salvar',
        },
      },
      performanceDocs: {
        title: 'Documentação: monitoramento e performance',
        subtitle:
          'Entenda os gráficos do painel de monitoramento e como funciona a configuração dinâmica de performance.',
        back: 'Voltar',
        sections: {
          howItWorks: 'Como funciona a configuração dinâmica',
          metrics: 'Métricas e gráficos do monitoramento',
          catalog: 'Catálogo de configurações',
          faq: 'Perguntas frequentes',
        },
        catalogTable: {
          intro:
            'Lista ao vivo, buscada direto do servidor — sempre reflete as configurações disponíveis no painel.',
          config: 'Configuração',
          description: 'Descrição',
          unit: 'Unidade',
          range: 'Faixa',
          scope: 'Escopo',
          mode: 'Modo',
          scopeGlobal: 'Global',
          scopeCompany: 'Por empresa',
          modeRuntime: 'Runtime',
          modeBoot: 'Boot (reinício)',
          modeReadonly: 'Somente leitura (.env)',
          noRange: '—',
          loadError: 'Não foi possível carregar o catálogo de configurações.',
        },
      },
    },
  },
};

export { messages };
